var map = {
	"./TRM": 1040,
	"./TRM.js": 1040,
	"./TRM/filter": 171,
	"./TRM/filter.js": 171,
	"./TRM/table": 172,
	"./TRM/table.js": 172,
	"./accounting/accounts": 1041,
	"./accounting/accounts.js": 1041,
	"./accounting/accounts/filter": 173,
	"./accounting/accounts/filter.js": 173,
	"./accounting/accounts/table": 174,
	"./accounting/accounts/table.js": 174,
	"./accounting/area": 1042,
	"./accounting/area.js": 1042,
	"./accounting/area/filter": 996,
	"./accounting/area/filter.js": 996,
	"./accounting/area/table": 175,
	"./accounting/area/table.js": 175,
	"./accounting/area_copy": 1043,
	"./accounting/area_copy.js": 1043,
	"./accounting/closingDayReport": 1044,
	"./accounting/closingDayReport.js": 1044,
	"./accounting/closingDayReport/filter": 176,
	"./accounting/closingDayReport/filter.js": 176,
	"./accounting/closingDayReport/table": 177,
	"./accounting/closingDayReport/table.js": 177,
	"./accounting/concepts": 1045,
	"./accounting/concepts.js": 1045,
	"./accounting/concepts/filter": 178,
	"./accounting/concepts/filter.js": 178,
	"./accounting/concepts/table": 179,
	"./accounting/concepts/table.js": 179,
	"./accounting/costCenter": 1046,
	"./accounting/costCenter.js": 1046,
	"./accounting/costCenter/filter": 180,
	"./accounting/costCenter/filter.js": 180,
	"./accounting/costCenter/table": 181,
	"./accounting/costCenter/table.js": 181,
	"./accounting/employees": 1047,
	"./accounting/employees.js": 1047,
	"./accounting/employees/filter": 997,
	"./accounting/employees/filter.js": 997,
	"./accounting/employees/table": 182,
	"./accounting/employees/table.js": 182,
	"./accounting/expenses": 1048,
	"./accounting/expenses.js": 1048,
	"./accounting/expenses/filter": 183,
	"./accounting/expenses/filter.js": 183,
	"./accounting/expenses/table": 184,
	"./accounting/expenses/table.js": 184,
	"./accounting/incomes": 1049,
	"./accounting/incomes.js": 1049,
	"./accounting/incomes/filter": 185,
	"./accounting/incomes/filter.js": 185,
	"./accounting/incomes/table": 186,
	"./accounting/incomes/table.js": 186,
	"./accounting/position": 1050,
	"./accounting/position.js": 1050,
	"./accounting/position/filter": 998,
	"./accounting/position/filter.js": 998,
	"./accounting/position/table": 187,
	"./accounting/position/table.js": 187,
	"./accounting/productsThirdBetShop": 1051,
	"./accounting/productsThirdBetShop.js": 1051,
	"./accounting/productsThirdBetShop/filter": 999,
	"./accounting/productsThirdBetShop/filter.js": 999,
	"./accounting/productsThirdBetShop/table": 188,
	"./accounting/productsThirdBetShop/table.js": 188,
	"./accounting/productsThirdByBetShop": 1052,
	"./accounting/productsThirdByBetShop.js": 1052,
	"./accounting/productsThirdByBetShop/filter": 189,
	"./accounting/productsThirdByBetShop/filter.js": 189,
	"./accounting/productsThirdByBetShop/table": 190,
	"./accounting/productsThirdByBetShop/table.js": 190,
	"./accounting/productsThirdQuota": 1053,
	"./accounting/productsThirdQuota.js": 1053,
	"./accounting/productsThirdQuota/filter": 191,
	"./accounting/productsThirdQuota/filter.js": 191,
	"./accounting/productsThirdQuota/table": 192,
	"./accounting/productsThirdQuota/table.js": 192,
	"./accounting/providers": 1054,
	"./accounting/providers.js": 1054,
	"./accounting/providers/filter": 1000,
	"./accounting/providers/filter.js": 1000,
	"./accounting/providers/table": 193,
	"./accounting/providers/table.js": 193,
	"./accounting/providers/tableProductsThirdBetShop": 1055,
	"./accounting/providers/tableProductsThirdBetShop.js": 1055,
	"./accounting/providers_copy": 1056,
	"./accounting/providers_copy.js": 1056,
	"./accounting/squareDayReport": 1057,
	"./accounting/squareDayReport.js": 1057,
	"./accounting/squareDayReport/filter": 194,
	"./accounting/squareDayReport/filter.js": 194,
	"./accounting/squareDayReport/table": 195,
	"./accounting/squareDayReport/table.js": 195,
	"./accounting/squareDayReport2": 1058,
	"./accounting/squareDayReport2.js": 1058,
	"./accounting/squareDayReport2/filter": 196,
	"./accounting/squareDayReport2/filter.js": 196,
	"./accounting/squareDayReport2/table": 197,
	"./accounting/squareDayReport2/table.js": 197,
	"./accounting/typeCenterPosition": 1059,
	"./accounting/typeCenterPosition.js": 1059,
	"./accounting/typeDocument": 1060,
	"./accounting/typeDocument.js": 1060,
	"./accounting/typeDocument/filter": 199,
	"./accounting/typeDocument/filter.js": 199,
	"./accounting/typeDocument/table": 200,
	"./accounting/typeDocument/table.js": 200,
	"./accounting/types/filter": 1001,
	"./accounting/types/filter.js": 1001,
	"./accounting/types/table": 198,
	"./accounting/types/table.js": 198,
	"./activateRegistration": 1061,
	"./activateRegistration.js": 1061,
	"./activeProviders": 1062,
	"./activeProviders.js": 1062,
	"./addAdminUserManagement": 1063,
	"./addAdminUserManagement.js": 1063,
	"./addAgentListManagement": 1064,
	"./addAgentListManagement.js": 1064,
	"./addBetShopManagement": 1065,
	"./addBetShopManagement.js": 1065,
	"./adminUser": 1066,
	"./adminUser.js": 1066,
	"./adminUserManagement": 1067,
	"./adminUserManagement.js": 1067,
	"./affiliatesBetShop": 1068,
	"./affiliatesBetShop.js": 1068,
	"./agent/addInformationAgentList": 1069,
	"./agent/addInformationAgentList.js": 1069,
	"./agent/age": 1070,
	"./agent/age.js": 1070,
	"./agent/agent-list/detailsAgentList": 209,
	"./agent/agent-list/detailsAgentList.js": 209,
	"./agent/agent-list/filterAgentList": 210,
	"./agent/agent-list/filterAgentList.js": 210,
	"./agent/agent-list/recordAgentList": 211,
	"./agent/agent-list/recordAgentList.js": 211,
	"./agent/agent-list/recordTableAgentList": 1002,
	"./agent/agent-list/recordTableAgentList.js": 1002,
	"./agent/agent-list/tableAgentList": 212,
	"./agent/agent-list/tableAgentList.js": 212,
	"./agent/agent-retraction/PagoPremio": 213,
	"./agent/agent-retraction/PagoPremio.js": 213,
	"./agent/agent-retraction/search": 214,
	"./agent/agent-retraction/search.js": 214,
	"./agent/agent-retraction/transfers": 215,
	"./agent/agent-retraction/transfers.js": 215,
	"./agent/agent-retraction/transfers1": 216,
	"./agent/agent-retraction/transfers1.js": 216,
	"./agent/agent-transfers/PagoPremio": 217,
	"./agent/agent-transfers/PagoPremio.js": 217,
	"./agent/agent-transfers/search": 218,
	"./agent/agent-transfers/search.js": 218,
	"./agent/agent-transfers/transfers": 219,
	"./agent/agent-transfers/transfers.js": 219,
	"./agent/agent-transfers/transfers1": 220,
	"./agent/agent-transfers/transfers1.js": 220,
	"./agent/agent-tree/details": 1003,
	"./agent/agent-tree/details.js": 1003,
	"./agent/agent-tree/filter": 221,
	"./agent/agent-tree/filter.js": 221,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 222,
	"./agent/agent-tree/recordTableAgentList.js": 222,
	"./agent/agent-tree/table": 223,
	"./agent/agent-tree/table.js": 223,
	"./agent/bonusReportAgentList": 1071,
	"./agent/bonusReportAgentList.js": 1071,
	"./agent/casinoGamesReportAgentList": 1072,
	"./agent/casinoGamesReportAgentList.js": 1072,
	"./agent/comissions": 1073,
	"./agent/comissions.js": 1073,
	"./agent/comissions/autoexclusionUsers": 1074,
	"./agent/comissions/autoexclusionUsers.js": 1074,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1075,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1075,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1076,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1076,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1077,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1077,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1078,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1078,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1079,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1079,
	"./agent/comissions/betsReport/detailsReport": 1080,
	"./agent/comissions/betsReport/detailsReport.js": 1080,
	"./agent/comissions/betsReport/filterReport": 1081,
	"./agent/comissions/betsReport/filterReport.js": 1081,
	"./agent/comissions/betsReport/recordReport": 1082,
	"./agent/comissions/betsReport/recordReport.js": 1082,
	"./agent/comissions/betsReport/recordTableReport": 1083,
	"./agent/comissions/betsReport/recordTableReport.js": 1083,
	"./agent/comissions/betsReport/recordTableTransReport": 1084,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1084,
	"./agent/comissions/betsReport/recordTransReport": 1085,
	"./agent/comissions/betsReport/recordTransReport.js": 1085,
	"./agent/comissions/betsReport/tableReport": 1086,
	"./agent/comissions/betsReport/tableReport.js": 1086,
	"./agent/comissions/betsReportBetShop": 1087,
	"./agent/comissions/betsReportBetShop.js": 1087,
	"./agent/comissions/bonusReport/detailsBonusReport": 1088,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1088,
	"./agent/comissions/bonusReport/filterBonusReport": 1089,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1089,
	"./agent/comissions/bonusReport/recordBonusReport": 1090,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1090,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1091,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1091,
	"./agent/comissions/bonusReport/tableBonusReport": 1092,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1092,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1093,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1093,
	"./agent/comissions/casinoReport/filterCasinoReport": 1094,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1094,
	"./agent/comissions/casinoReport/recordCasinoReport": 1095,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1095,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1096,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1096,
	"./agent/comissions/casinoReport/tableCasinoReport": 1097,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1097,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1098,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1098,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1099,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1099,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1100,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1100,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1101,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1101,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1102,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1102,
	"./agent/comissions/comissions": 1103,
	"./agent/comissions/comissions.js": 1103,
	"./agent/comissions/comissions/table": 232,
	"./agent/comissions/comissions/table.js": 232,
	"./agent/comissions/comissionsReportBetShop": 1104,
	"./agent/comissions/comissionsReportBetShop.js": 1104,
	"./agent/comissions/comissionsReportBetShopDetail": 1105,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1105,
	"./agent/comissions/comissions_report/detailsDepositReports": 1106,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1106,
	"./agent/comissions/comissions_report/filter": 233,
	"./agent/comissions/comissions_report/filter.js": 233,
	"./agent/comissions/comissions_report/recordDepositReports": 1107,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1107,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1108,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1108,
	"./agent/comissions/comissions_report/table": 234,
	"./agent/comissions/comissions_report/table.js": 234,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1109,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1109,
	"./agent/comissions/comissions_report_detail/filter": 235,
	"./agent/comissions/comissions_report_detail/filter.js": 235,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1110,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1110,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1111,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1111,
	"./agent/comissions/comissions_report_detail/table": 236,
	"./agent/comissions/comissions_report_detail/table.js": 236,
	"./agent/comissions/expenses": 1112,
	"./agent/comissions/expenses.js": 1112,
	"./agent/comissions/expenses/filter": 1113,
	"./agent/comissions/expenses/filter.js": 1113,
	"./agent/comissions/expenses/table": 1114,
	"./agent/comissions/expenses/table.js": 1114,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1115,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1115,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1116,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1116,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1117,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1117,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1118,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1118,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1119,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1119,
	"./agent/comissions/incomes": 1120,
	"./agent/comissions/incomes.js": 1120,
	"./agent/comissions/incomes/filter": 1121,
	"./agent/comissions/incomes/filter.js": 1121,
	"./agent/comissions/incomes/table": 1122,
	"./agent/comissions/incomes/table.js": 1122,
	"./agent/comissions/productsThird": 1123,
	"./agent/comissions/productsThird.js": 1123,
	"./agent/comissions/productsThird/filter": 1124,
	"./agent/comissions/productsThird/filter.js": 1124,
	"./agent/comissions/productsThird/table": 1125,
	"./agent/comissions/productsThird/table.js": 1125,
	"./agent/comissions/promotionalCodes": 1126,
	"./agent/comissions/promotionalCodes.js": 1126,
	"./agent/comissions/promotionalCodes/filter": 1127,
	"./agent/comissions/promotionalCodes/filter.js": 1127,
	"./agent/comissions/promotionalCodes/table": 1128,
	"./agent/comissions/promotionalCodes/table.js": 1128,
	"./agent/comissions/withdrawalRequests": 1129,
	"./agent/comissions/withdrawalRequests.js": 1129,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 239,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 237,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 237,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1130,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1130,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 238,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 238,
	"./agent/configuration/changePassword": 1131,
	"./agent/configuration/changePassword.js": 1131,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1132,
	"./agent/configuration/generateToken.js": 1132,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1133,
	"./agent/configuration/qrgoogle.js": 1133,
	"./agent/configuration/securityChanges": 1134,
	"./agent/configuration/securityChanges.js": 1134,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1135,
	"./agent/configurationAgentList.js": 1135,
	"./agent/depositReportAgentList": 1136,
	"./agent/depositReportAgentList.js": 1136,
	"./agent/financescustomerAgentList": 1137,
	"./agent/financescustomerAgentList.js": 1137,
	"./agent/financial/comisiones": 1138,
	"./agent/financial/comisiones.js": 1138,
	"./agent/financial/comisiones/table": 243,
	"./agent/financial/comisiones/table.js": 243,
	"./agent/financial/informationFinancialAgentList": 1139,
	"./agent/financial/informationFinancialAgentList.js": 1139,
	"./agent/financial/withdrawalRequestsAgentList": 1140,
	"./agent/financial/withdrawalRequestsAgentList.js": 1140,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 244,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 244,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1141,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1141,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 245,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 245,
	"./agent/flujoCajaAgentList": 1142,
	"./agent/flujoCajaAgentList.js": 1142,
	"./agent/flujoCajaHijosAgentList": 1143,
	"./agent/flujoCajaHijosAgentList.js": 1143,
	"./agent/geo": 1144,
	"./agent/geo.js": 1144,
	"./agent/informationAgentList": 1145,
	"./agent/informationAgentList.js": 1145,
	"./agent/informeRed/details": 1146,
	"./agent/informeRed/details.js": 1146,
	"./agent/informeRed/filter": 252,
	"./agent/informeRed/filter.js": 252,
	"./agent/informeRed/record": 1147,
	"./agent/informeRed/record.js": 1147,
	"./agent/informeRed/recordTable": 1148,
	"./agent/informeRed/recordTable.js": 1148,
	"./agent/informeRed/table": 253,
	"./agent/informeRed/table.js": 253,
	"./agent/money": 1149,
	"./agent/money.js": 1149,
	"./agent/paymenthistory": 1150,
	"./agent/paymenthistory.js": 1150,
	"./agent/positions": 1151,
	"./agent/positions.js": 1151,
	"./agent/reports/autoexclusionUsers": 1152,
	"./agent/reports/autoexclusionUsers.js": 1152,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1153,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1153,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1154,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1154,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1155,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1155,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1156,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1156,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1157,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1157,
	"./agent/reports/balanceTransactionReport": 1158,
	"./agent/reports/balanceTransactionReport.js": 1158,
	"./agent/reports/balanceTransactionReport/filter": 254,
	"./agent/reports/balanceTransactionReport/filter.js": 254,
	"./agent/reports/balanceTransactionReport/table": 255,
	"./agent/reports/balanceTransactionReport/table.js": 255,
	"./agent/reports/betsReport/detailsReport": 1159,
	"./agent/reports/betsReport/detailsReport.js": 1159,
	"./agent/reports/betsReport/filterReport": 256,
	"./agent/reports/betsReport/filterReport.js": 256,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1160,
	"./agent/reports/betsReport/recordTableReport.js": 1160,
	"./agent/reports/betsReport/recordTableTransReport": 1161,
	"./agent/reports/betsReport/recordTableTransReport.js": 1161,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 257,
	"./agent/reports/betsReport/tableReport.js": 257,
	"./agent/reports/betsReportAgentList": 1162,
	"./agent/reports/betsReportAgentList.js": 1162,
	"./agent/reports/bonusReport/detailsBonusReport": 226,
	"./agent/reports/bonusReport/detailsBonusReport.js": 226,
	"./agent/reports/bonusReport/filterBonusReport": 224,
	"./agent/reports/bonusReport/filterBonusReport.js": 224,
	"./agent/reports/bonusReport/recordBonusReport": 227,
	"./agent/reports/bonusReport/recordBonusReport.js": 227,
	"./agent/reports/bonusReport/recordTableBonusReport": 1163,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1163,
	"./agent/reports/bonusReport/tableBonusReport": 225,
	"./agent/reports/bonusReport/tableBonusReport.js": 225,
	"./agent/reports/casinoReport/detailsCasinoReport": 230,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 230,
	"./agent/reports/casinoReport/filterCasinoReport": 228,
	"./agent/reports/casinoReport/filterCasinoReport.js": 228,
	"./agent/reports/casinoReport/recordCasinoReport": 231,
	"./agent/reports/casinoReport/recordCasinoReport.js": 231,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1164,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1164,
	"./agent/reports/casinoReport/tableCasinoReport": 229,
	"./agent/reports/casinoReport/tableCasinoReport.js": 229,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1165,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1165,
	"./agent/reports/casinoReport2/filterCasinoReport": 1166,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1166,
	"./agent/reports/casinoReport2/recordCasinoReport": 1167,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1167,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1168,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1168,
	"./agent/reports/casinoReport2/tableCasinoReport": 1169,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1169,
	"./agent/reports/deposit_report/detailsDepositReports": 1170,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1170,
	"./agent/reports/deposit_report/filterDepositReports": 241,
	"./agent/reports/deposit_report/filterDepositReports.js": 241,
	"./agent/reports/deposit_report/recordDepositReports": 1171,
	"./agent/reports/deposit_report/recordDepositReports.js": 1171,
	"./agent/reports/deposit_report/recordTableDepositReports": 1172,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1172,
	"./agent/reports/deposit_report/tableDepositReports": 242,
	"./agent/reports/deposit_report/tableDepositReports.js": 242,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1173,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1173,
	"./agent/reports/flujocaja/filterFlujoCaja": 246,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 246,
	"./agent/reports/flujocaja/recordFlujoCaja": 1174,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1174,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1175,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1175,
	"./agent/reports/flujocaja/tableFlujoCaja": 247,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 247,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 248,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 248,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 251,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1176,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1176,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 249,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 249,
	"./agent/reports/managementReport": 1177,
	"./agent/reports/managementReport.js": 1177,
	"./agent/reports/managementReport/filterReports": 258,
	"./agent/reports/managementReport/filterReports.js": 258,
	"./agent/reports/managementReport/tableReports": 259,
	"./agent/reports/managementReport/tableReports.js": 259,
	"./agent/reports/marketing/filterReports": 260,
	"./agent/reports/marketing/filterReports.js": 260,
	"./agent/reports/marketing/tableReports": 261,
	"./agent/reports/marketing/tableReports.js": 261,
	"./agent/reports/marketingReport": 1178,
	"./agent/reports/marketingReport.js": 1178,
	"./agent/reports/promotionalCodes": 1179,
	"./agent/reports/promotionalCodes.js": 1179,
	"./agent/reports/promotionalCodes/filter": 262,
	"./agent/reports/promotionalCodes/filter.js": 262,
	"./agent/reports/promotionalCodes/table": 263,
	"./agent/reports/promotionalCodes/table.js": 263,
	"./agent/reports/quotaRetractionReport/filter": 264,
	"./agent/reports/quotaRetractionReport/filter.js": 264,
	"./agent/reports/quotaRetractionReport/table": 265,
	"./agent/reports/quotaRetractionReport/table.js": 265,
	"./agent/reports/quotaRetractionReportAgent": 1180,
	"./agent/reports/quotaRetractionReportAgent.js": 1180,
	"./agent/reports/transfersReport/filter": 266,
	"./agent/reports/transfersReport/filter.js": 266,
	"./agent/reports/transfersReport/table": 267,
	"./agent/reports/transfersReport/table.js": 267,
	"./agent/reports/trasnfersReport": 1181,
	"./agent/reports/trasnfersReport.js": 1181,
	"./agent/reports/userAfilliatesReport": 1182,
	"./agent/reports/userAfilliatesReport.js": 1182,
	"./agent/reports/user_affiliates/detailsReports": 270,
	"./agent/reports/user_affiliates/detailsReports.js": 270,
	"./agent/reports/user_affiliates/filterReports": 268,
	"./agent/reports/user_affiliates/filterReports.js": 268,
	"./agent/reports/user_affiliates/recordReports": 271,
	"./agent/reports/user_affiliates/recordReports.js": 271,
	"./agent/reports/user_affiliates/recordTableReports": 1183,
	"./agent/reports/user_affiliates/recordTableReports.js": 1183,
	"./agent/reports/user_affiliates/tableReports": 269,
	"./agent/reports/user_affiliates/tableReports.js": 269,
	"./agent/reportscustomerAgentList": 1184,
	"./agent/reportscustomerAgentList.js": 1184,
	"./agent/requestsAgent": 1185,
	"./agent/requestsAgent.js": 1185,
	"./agent/requestsAgent/filter": 272,
	"./agent/requestsAgent/filter.js": 272,
	"./agent/requestsAgent/table": 273,
	"./agent/requestsAgent/table.js": 273,
	"./agent/requirementsAgent": 1186,
	"./agent/requirementsAgent.js": 1186,
	"./agent/requirementsAgent/details": 276,
	"./agent/requirementsAgent/details.js": 276,
	"./agent/requirementsAgent/detailsFilter": 278,
	"./agent/requirementsAgent/detailsFilter.js": 278,
	"./agent/requirementsAgent/detailsTable": 277,
	"./agent/requirementsAgent/detailsTable.js": 277,
	"./agent/requirementsAgent/filter": 274,
	"./agent/requirementsAgent/filter.js": 274,
	"./agent/requirementsAgent/table": 275,
	"./agent/requirementsAgent/table.js": 275,
	"./agent/statistics/age": 279,
	"./agent/statistics/age.js": 279,
	"./agent/statistics/marketing": 280,
	"./agent/statistics/marketing.js": 280,
	"./agent/statistics/marketingvsregistros": 281,
	"./agent/statistics/marketingvsregistros.js": 281,
	"./agent/statistics/money": 282,
	"./agent/statistics/money.js": 282,
	"./agent/statisticsAgentList": 1187,
	"./agent/statisticsAgentList.js": 1187,
	"./agent/tags": 1188,
	"./agent/tags.js": 1188,
	"./agentList": 1189,
	"./agentList.js": 1189,
	"./agentListManagement": 1190,
	"./agentListManagement.js": 1190,
	"./agentRetraction": 1191,
	"./agentRetraction.js": 1191,
	"./agentTransfers": 1192,
	"./agentTransfers.js": 1192,
	"./agentsInform": 1193,
	"./agentsInform.js": 1193,
	"./agentsTree": 1194,
	"./agentsTree.js": 1194,
	"./alltactions": 283,
	"./alltactions.js": 283,
	"./approvalLogs": 1195,
	"./approvalLogs.js": 1195,
	"./approvalLogs2": 1196,
	"./approvalLogs2.js": 1196,
	"./approvalLogsBetShop": 1197,
	"./approvalLogsBetShop.js": 1197,
	"./assignmentQuotaMade": 1198,
	"./assignmentQuotaMade.js": 1198,
	"./assignmentQuotaR": 1199,
	"./assignmentQuotaR.js": 1199,
	"./autoexclusionUsers": 1200,
	"./autoexclusionUsers.js": 1200,
	"./balanceAdjustments": 1201,
	"./balanceAdjustments.js": 1201,
	"./balanceHistory": 1202,
	"./balanceHistory.js": 1202,
	"./balanceHistory2": 1203,
	"./balanceHistory2.js": 1203,
	"./balanceHistoryAdminUser": 1204,
	"./balanceHistoryAdminUser.js": 1204,
	"./balanceHistoryBetShop": 1205,
	"./balanceHistoryBetShop.js": 1205,
	"./balanceHistoryBetShop2": 1206,
	"./balanceHistoryBetShop2.js": 1206,
	"./balanceHistoryForAgent": 1207,
	"./balanceHistoryForAgent.js": 1207,
	"./balanceHistoryForBetShop": 1208,
	"./balanceHistoryForBetShop.js": 1208,
	"./balanceHistoryMachine": 1209,
	"./balanceHistoryMachine.js": 1209,
	"./balanceUsers": 1210,
	"./balanceUsers.js": 1210,
	"./bankAccounts": 1211,
	"./bankAccounts.js": 1211,
	"./banks": 1212,
	"./banks.js": 1212,
	"./betShop": 1213,
	"./betShop.js": 1213,
	"./betShopCompetence": 1214,
	"./betShopCompetence.js": 1214,
	"./betShopManagement": 1215,
	"./betShopManagement.js": 1215,
	"./betShopManagement/addInformationBetShop": 1216,
	"./betShopManagement/addInformationBetShop.js": 1216,
	"./betShopManagement/age": 1217,
	"./betShopManagement/age.js": 1217,
	"./betShopManagement/betShop/detailsBetShop": 1004,
	"./betShopManagement/betShop/detailsBetShop.js": 1004,
	"./betShopManagement/betShop/filterBetShop": 324,
	"./betShopManagement/betShop/filterBetShop.js": 324,
	"./betShopManagement/betShop/recordBetShop": 326,
	"./betShopManagement/betShop/recordBetShop.js": 326,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 325,
	"./betShopManagement/betShop/tableBetShop.js": 325,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1218,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1218,
	"./betShopManagement/betShopCompetence/filterBetShop": 327,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 327,
	"./betShopManagement/betShopCompetence/recordBetShop": 1219,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1219,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1220,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1220,
	"./betShopManagement/betShopCompetence/tableBetShop": 328,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 328,
	"./betShopManagement/bonusReportBetShop": 1221,
	"./betShopManagement/bonusReportBetShop.js": 1221,
	"./betShopManagement/cashier/betShopAdvertising": 333,
	"./betShopManagement/cashier/betShopAdvertising.js": 333,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 335,
	"./betShopManagement/cashier/betShopCashier": 1222,
	"./betShopManagement/cashier/betShopCashier.js": 1222,
	"./betShopManagement/cashier/betShopComissions": 1005,
	"./betShopManagement/cashier/betShopComissions.js": 1005,
	"./betShopManagement/cashier/filterCashier": 338,
	"./betShopManagement/cashier/filterCashier.js": 338,
	"./betShopManagement/cashier/tableAdvertising": 334,
	"./betShopManagement/cashier/tableAdvertising.js": 334,
	"./betShopManagement/cashier/tableAdvertisingCashier": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 336,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 337,
	"./betShopManagement/cashier/tableComissions.js": 337,
	"./betShopManagement/casinoGamesReportBetShop": 1223,
	"./betShopManagement/casinoGamesReportBetShop.js": 1223,
	"./betShopManagement/comissions": 1224,
	"./betShopManagement/comissions.js": 1224,
	"./betShopManagement/comissions/autoexclusionUsers": 1225,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1225,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1226,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1226,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1227,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1227,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1228,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1228,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1229,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1229,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1230,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1230,
	"./betShopManagement/comissions/betsReport/detailsReport": 1231,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1231,
	"./betShopManagement/comissions/betsReport/filterReport": 1232,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1232,
	"./betShopManagement/comissions/betsReport/recordReport": 1233,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1233,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1234,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1234,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1235,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1235,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1236,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1236,
	"./betShopManagement/comissions/betsReport/tableReport": 1237,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1237,
	"./betShopManagement/comissions/betsReportBetShop": 1238,
	"./betShopManagement/comissions/betsReportBetShop.js": 1238,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1239,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1239,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1240,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1240,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1241,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1241,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1242,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1242,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1243,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1243,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1244,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1244,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1245,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1245,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1246,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1246,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1247,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1247,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1248,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1248,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1249,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1249,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1250,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1250,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1251,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1251,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1252,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1252,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1253,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1253,
	"./betShopManagement/comissions/comissions": 1254,
	"./betShopManagement/comissions/comissions.js": 1254,
	"./betShopManagement/comissions/comissions/table": 343,
	"./betShopManagement/comissions/comissions/table.js": 343,
	"./betShopManagement/comissions/comissionsReportBetShop": 1255,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1255,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1256,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1256,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1257,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1257,
	"./betShopManagement/comissions/comissions_report/filter": 344,
	"./betShopManagement/comissions/comissions_report/filter.js": 344,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1258,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1258,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1259,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1259,
	"./betShopManagement/comissions/comissions_report/table": 345,
	"./betShopManagement/comissions/comissions_report/table.js": 345,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1260,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1260,
	"./betShopManagement/comissions/comissions_report_detail/filter": 346,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 346,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1261,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1261,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1262,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1262,
	"./betShopManagement/comissions/comissions_report_detail/table": 347,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 347,
	"./betShopManagement/comissions/expenses": 1263,
	"./betShopManagement/comissions/expenses.js": 1263,
	"./betShopManagement/comissions/expenses/filter": 1264,
	"./betShopManagement/comissions/expenses/filter.js": 1264,
	"./betShopManagement/comissions/expenses/table": 1265,
	"./betShopManagement/comissions/expenses/table.js": 1265,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1266,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1266,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1267,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1267,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1268,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1268,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1269,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1269,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1270,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1270,
	"./betShopManagement/comissions/incomes": 1271,
	"./betShopManagement/comissions/incomes.js": 1271,
	"./betShopManagement/comissions/incomes/filter": 1272,
	"./betShopManagement/comissions/incomes/filter.js": 1272,
	"./betShopManagement/comissions/incomes/table": 1273,
	"./betShopManagement/comissions/incomes/table.js": 1273,
	"./betShopManagement/comissions/productsThird": 1274,
	"./betShopManagement/comissions/productsThird.js": 1274,
	"./betShopManagement/comissions/productsThird/filter": 1275,
	"./betShopManagement/comissions/productsThird/filter.js": 1275,
	"./betShopManagement/comissions/productsThird/table": 1276,
	"./betShopManagement/comissions/productsThird/table.js": 1276,
	"./betShopManagement/comissions/promotionalCodes": 1277,
	"./betShopManagement/comissions/promotionalCodes.js": 1277,
	"./betShopManagement/comissions/promotionalCodes/filter": 1278,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1278,
	"./betShopManagement/comissions/promotionalCodes/table": 1279,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1279,
	"./betShopManagement/comissions/withdrawalRequests": 1280,
	"./betShopManagement/comissions/withdrawalRequests.js": 1280,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 350,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 348,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 348,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1281,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1281,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 349,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 349,
	"./betShopManagement/configuration/changePassword": 1282,
	"./betShopManagement/configuration/changePassword.js": 1282,
	"./betShopManagement/configuration/changePassword/changePasswordView": 352,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 352,
	"./betShopManagement/configuration/generateToken": 1283,
	"./betShopManagement/configuration/generateToken.js": 1283,
	"./betShopManagement/configuration/generateToken/filter": 353,
	"./betShopManagement/configuration/generateToken/filter.js": 353,
	"./betShopManagement/configuration/generateToken/table": 354,
	"./betShopManagement/configuration/generateToken/table.js": 354,
	"./betShopManagement/configuration/qrgoogle": 1284,
	"./betShopManagement/configuration/qrgoogle.js": 1284,
	"./betShopManagement/configuration/securityChanges": 1285,
	"./betShopManagement/configuration/securityChanges.js": 1285,
	"./betShopManagement/configuration/securityChanges/filter": 1006,
	"./betShopManagement/configuration/securityChanges/filter.js": 1006,
	"./betShopManagement/configuration/securityChanges/table": 355,
	"./betShopManagement/configuration/securityChanges/table.js": 355,
	"./betShopManagement/configurationBetShop": 1286,
	"./betShopManagement/configurationBetShop.js": 1286,
	"./betShopManagement/depositReportBetShop": 1287,
	"./betShopManagement/depositReportBetShop.js": 1287,
	"./betShopManagement/financescustomerBetShop": 1288,
	"./betShopManagement/financescustomerBetShop.js": 1288,
	"./betShopManagement/financial/bankAccountsBetShop": 1289,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1289,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1290,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1290,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 358,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 358,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1291,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1291,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1292,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1292,
	"./betShopManagement/financial/bankAccountsBetShop/table": 359,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 359,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1293,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1293,
	"./betShopManagement/financial/informationFinancialBetShop": 1294,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1294,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1295,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1295,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 362,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 362,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 361,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 361,
	"./betShopManagement/flujoCajaBetShop": 1296,
	"./betShopManagement/flujoCajaBetShop.js": 1296,
	"./betShopManagement/geo": 1297,
	"./betShopManagement/geo.js": 1297,
	"./betShopManagement/informationBetShop": 1298,
	"./betShopManagement/informationBetShop.js": 1298,
	"./betShopManagement/money": 1299,
	"./betShopManagement/money.js": 1299,
	"./betShopManagement/paymenthistory": 1300,
	"./betShopManagement/paymenthistory.js": 1300,
	"./betShopManagement/positions": 1301,
	"./betShopManagement/positions.js": 1301,
	"./betShopManagement/reports/autoexclusionUsers": 1302,
	"./betShopManagement/reports/autoexclusionUsers.js": 1302,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1303,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1303,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1304,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1304,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1305,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1305,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1306,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1306,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1307,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1307,
	"./betShopManagement/reports/balanceTransactionReport": 1308,
	"./betShopManagement/reports/balanceTransactionReport.js": 1308,
	"./betShopManagement/reports/balanceTransactionReport/filter": 365,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 365,
	"./betShopManagement/reports/balanceTransactionReport/table": 366,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 366,
	"./betShopManagement/reports/betsReport/detailsReport": 1309,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1309,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1310,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1310,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1311,
	"./betShopManagement/reports/betsReportBetShop.js": 1311,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 331,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 329,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 329,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 332,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 332,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1312,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1312,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 330,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 330,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 339,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 339,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1313,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1313,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 340,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 340,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1314,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1314,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1315,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1315,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1316,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1316,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1317,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1317,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1318,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1318,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1007,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1007,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 356,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 356,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1319,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1319,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 357,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 357,
	"./betShopManagement/reports/expenses": 1320,
	"./betShopManagement/reports/expenses.js": 1320,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1321,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1321,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 363,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 363,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1322,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1322,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1323,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1323,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 364,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 364,
	"./betShopManagement/reports/historyMovement": 1324,
	"./betShopManagement/reports/historyMovement.js": 1324,
	"./betShopManagement/reports/historyMovement/filter": 367,
	"./betShopManagement/reports/historyMovement/filter.js": 367,
	"./betShopManagement/reports/historyMovement/table": 368,
	"./betShopManagement/reports/historyMovement/table.js": 368,
	"./betShopManagement/reports/incomes": 1325,
	"./betShopManagement/reports/incomes.js": 1325,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1326,
	"./betShopManagement/reports/productsThird.js": 1326,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1327,
	"./betShopManagement/reports/promotionalCodes.js": 1327,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1328,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1328,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 369,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 369,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 370,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 370,
	"./betShopManagement/reportscustomerBetShop": 1329,
	"./betShopManagement/reportscustomerBetShop.js": 1329,
	"./betShopManagement/statisticsBetShop": 1330,
	"./betShopManagement/statisticsBetShop.js": 1330,
	"./betShopManagement/tags": 1331,
	"./betShopManagement/tags.js": 1331,
	"./betsHistory": 1332,
	"./betsHistory.js": 1332,
	"./betsHistory2": 1333,
	"./betsHistory2.js": 1333,
	"./betsReport": 1334,
	"./betsReport.js": 1334,
	"./betsReportBetShop": 1335,
	"./betsReportBetShop.js": 1335,
	"./betsReportSecond": 1336,
	"./betsReportSecond.js": 1336,
	"./betsSport": 1337,
	"./betsSport.js": 1337,
	"./betsSportLive": 1338,
	"./betsSportLive.js": 1338,
	"./betsVirtual": 1339,
	"./betsVirtual.js": 1339,
	"./betting": 1340,
	"./betting.js": 1340,
	"./bettingVirtual": 1341,
	"./bettingVirtual.js": 1341,
	"./blockchains": 1342,
	"./blockchains.js": 1342,
	"./bonusReport": 1343,
	"./bonusReport.js": 1343,
	"./bonusReport2": 1344,
	"./bonusReport2.js": 1344,
	"./cash/bankAccounts/filter": 319,
	"./cash/bankAccounts/filter.js": 319,
	"./cash/bankAccounts/table": 320,
	"./cash/bankAccounts/table.js": 320,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1345,
	"./cash/bets/betHistory2.js": 1345,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 375,
	"./cash/bets/sportLive.js": 375,
	"./cash/bets/sportVirtual": 376,
	"./cash/bets/sportVirtual.js": 376,
	"./cash/closeBox-edit/creditCards": 383,
	"./cash/closeBox-edit/creditCards.js": 383,
	"./cash/closeBox-edit/otherExpenses": 384,
	"./cash/closeBox-edit/otherExpenses.js": 384,
	"./cash/closeBox-edit/otherIncome": 385,
	"./cash/closeBox-edit/otherIncome.js": 385,
	"./cash/closeBox-edit/products": 386,
	"./cash/closeBox-edit/products.js": 386,
	"./cash/closeBox-edit/total": 387,
	"./cash/closeBox-edit/total.js": 387,
	"./cash/closeBox-old/otherExpenses": 1346,
	"./cash/closeBox-old/otherExpenses.js": 1346,
	"./cash/closeBox-old/otherIncome": 1347,
	"./cash/closeBox-old/otherIncome.js": 1347,
	"./cash/closeBox-old/products": 1348,
	"./cash/closeBox-old/products.js": 1348,
	"./cash/closeBox-old/total": 1349,
	"./cash/closeBox-old/total.js": 1349,
	"./cash/closeBox/creditCards": 388,
	"./cash/closeBox/creditCards.js": 388,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 389,
	"./cash/flujocaja/detailsFlujoCaja.js": 389,
	"./cash/flujocaja/filterFlujoCaja": 390,
	"./cash/flujocaja/filterFlujoCaja.js": 390,
	"./cash/flujocaja/recordFlujoCaja": 391,
	"./cash/flujocaja/recordFlujoCaja.js": 391,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 392,
	"./cash/flujocaja/tableFlujoCaja.js": 392,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 393,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 393,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 394,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 394,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1008,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1008,
	"./cash/pagopremio/PagoPremio": 395,
	"./cash/pagopremio/PagoPremio.js": 395,
	"./cash/pagopremio/detailsPagoPremio": 396,
	"./cash/pagopremio/detailsPagoPremio.js": 396,
	"./cash/pagopremio/filterPagoPremio": 397,
	"./cash/pagopremio/filterPagoPremio.js": 397,
	"./cash/pagopremio/recordPagoPremio": 398,
	"./cash/pagopremio/recordPagoPremio.js": 398,
	"./cash/pagopremio/recordTablePagoPremio": 1350,
	"./cash/pagopremio/recordTablePagoPremio.js": 1350,
	"./cash/pagopremio/tablePagoPremio": 399,
	"./cash/pagopremio/tablePagoPremio.js": 399,
	"./cash/pagopremiovirtuales/PagoPremio": 400,
	"./cash/pagopremiovirtuales/PagoPremio.js": 400,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 401,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 401,
	"./cash/pagopremiovirtuales/filterPagoPremio": 402,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 402,
	"./cash/pagopremiovirtuales/recordPagoPremio": 403,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 403,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1351,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1351,
	"./cash/pagopremiovirtuales/tablePagoPremio": 404,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 404,
	"./cash/payPrizesLoyalty/PagoPremio": 405,
	"./cash/payPrizesLoyalty/PagoPremio.js": 405,
	"./cash/payPrizesLoyalty/filterPagoPremio": 406,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 406,
	"./cash/recargacredito/RecargaCredito": 407,
	"./cash/recargacredito/RecargaCredito.js": 407,
	"./cash/recargacredito/filterRecargaCredito": 408,
	"./cash/recargacredito/filterRecargaCredito.js": 408,
	"./cash/recargacreditoAgent/RecargaCredito": 409,
	"./cash/recargacreditoAgent/RecargaCredito.js": 409,
	"./cash/recargacreditoAgent/filterRecargaCredito": 410,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 410,
	"./cash/withdrawal/filter": 411,
	"./cash/withdrawal/filter.js": 411,
	"./cash/withdrawal/table": 412,
	"./cash/withdrawal/table.js": 412,
	"./cashiers": 1352,
	"./cashiers.js": 1352,
	"./casinoGamesReport": 1353,
	"./casinoGamesReport.js": 1353,
	"./casinoGamesReport2": 1354,
	"./casinoGamesReport2.js": 1354,
	"./categories": 1355,
	"./categories.js": 1355,
	"./categoriesProducts": 1356,
	"./categoriesProducts.js": 1356,
	"./closeBox": 1357,
	"./closeBox-old": 1358,
	"./closeBox-old.js": 1358,
	"./closeBox.js": 1357,
	"./closeBoxEdit": 1359,
	"./closeBoxEdit.js": 1359,
	"./comissionsReport": 1360,
	"./comissionsReport.js": 1360,
	"./comissionsReport2": 1361,
	"./comissionsReport2.js": 1361,
	"./commisionsPay": 1362,
	"./commisionsPay.js": 1362,
	"./competitors/competitors": 1363,
	"./competitors/competitors.js": 1363,
	"./competitors/filter": 429,
	"./competitors/filter.js": 429,
	"./competitors/table": 430,
	"./competitors/table.js": 430,
	"./consolidatedIncomeOwner": 1364,
	"./consolidatedIncomeOwner.js": 1364,
	"./consolidatedIncomeOwner2": 1365,
	"./consolidatedIncomeOwner2.js": 1365,
	"./contingency": 1366,
	"./contingency.js": 1366,
	"./countries": 1367,
	"./countries.js": 1367,
	"./coupons": 1368,
	"./coupons.js": 1368,
	"./couponsReport": 1369,
	"./couponsReport.js": 1369,
	"./cryptoBlockchain": 1370,
	"./cryptoBlockchain.js": 1370,
	"./cryptos": 1371,
	"./cryptos.js": 1371,
	"./customReport": 1372,
	"./customReport.js": 1372,
	"./customers": 1373,
	"./customers.js": 1373,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1374,
	"./customers/bonusReport.js": 1374,
	"./customers/bonusReport2": 1375,
	"./customers/bonusReport2.js": 1375,
	"./customers/casinoGamesReport": 1376,
	"./customers/casinoGamesReport.js": 1376,
	"./customers/configuration": 1377,
	"./customers/configuration.js": 1377,
	"./customers/configuration/changePassword": 1378,
	"./customers/configuration/changePassword.js": 1378,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1379,
	"./customers/configuration/generateToken.js": 1379,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1380,
	"./customers/configuration/limitChanges.js": 1380,
	"./customers/configuration/securityChanges": 1381,
	"./customers/configuration/securityChanges.js": 1381,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1382,
	"./customers/configuration/securityChanges2.js": 1382,
	"./customers/depositReport": 1383,
	"./customers/depositReport.js": 1383,
	"./customers/financescustomer": 1384,
	"./customers/financescustomer.js": 1384,
	"./customers/financial/bankAccounts": 1385,
	"./customers/financial/bankAccounts.js": 1385,
	"./customers/financial/bankAccounts/details": 1013,
	"./customers/financial/bankAccounts/details.js": 1013,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 450,
	"./customers/financial/bankAccounts/record.js": 450,
	"./customers/financial/bankAccounts/recordTable": 1386,
	"./customers/financial/bankAccounts/recordTable.js": 1386,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1387,
	"./customers/financial/bankAccounts/tablePopup.js": 1387,
	"./customers/financial/informationFinancial": 1388,
	"./customers/financial/informationFinancial.js": 1388,
	"./customers/financial/withdrawalRequests": 1389,
	"./customers/financial/withdrawalRequests.js": 1389,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1390,
	"./customers/information.js": 1390,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 451,
	"./customers/paymenthistory.js": 451,
	"./customers/players/filter": 452,
	"./customers/players/filter.js": 452,
	"./customers/players/table": 453,
	"./customers/players/table.js": 453,
	"./customers/players2/filter": 454,
	"./customers/players2/filter.js": 454,
	"./customers/players2/table": 455,
	"./customers/players2/table.js": 455,
	"./customers/playersAggregator/filter": 456,
	"./customers/playersAggregator/filter.js": 456,
	"./customers/playersAggregator/table": 457,
	"./customers/playersAggregator/table.js": 457,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1391,
	"./customers/referralsReport.js": 1391,
	"./customers/reports/autoexclusionUsers": 1392,
	"./customers/reports/autoexclusionUsers.js": 1392,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1393,
	"./customers/reports/balanceAdjustments.js": 1393,
	"./customers/reports/balanceAdjustments/filter": 460,
	"./customers/reports/balanceAdjustments/filter.js": 460,
	"./customers/reports/balanceAdjustments/table": 461,
	"./customers/reports/balanceAdjustments/table.js": 461,
	"./customers/reports/balanceHistory": 1394,
	"./customers/reports/balanceHistory.js": 1394,
	"./customers/reports/balanceHistory/filter": 462,
	"./customers/reports/balanceHistory/filter.js": 462,
	"./customers/reports/balanceHistory/table": 463,
	"./customers/reports/balanceHistory/table.js": 463,
	"./customers/reports/betsReport": 1395,
	"./customers/reports/betsReport.js": 1395,
	"./customers/reports/betsReport/detailsReport": 1396,
	"./customers/reports/betsReport/detailsReport.js": 1396,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 448,
	"./customers/reports/bonusReport2/filterBonusReport.js": 448,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1397,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1397,
	"./customers/reports/bonusReport2/tableBonusReport": 449,
	"./customers/reports/bonusReport2/tableBonusReport.js": 449,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1398,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1398,
	"./customers/reports/casinoReport2/filterCasinoReport": 1399,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1399,
	"./customers/reports/casinoReport2/recordCasinoReport": 1400,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1400,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1401,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1401,
	"./customers/reports/casinoReport2/tableCasinoReport": 1402,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1402,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1403,
	"./customers/reports/historyMovement.js": 1403,
	"./customers/reports/historyMovement/filter": 464,
	"./customers/reports/historyMovement/filter.js": 464,
	"./customers/reports/historyMovement/table": 465,
	"./customers/reports/historyMovement/table.js": 465,
	"./customers/reports/historyPoints": 1404,
	"./customers/reports/historyPoints.js": 1404,
	"./customers/reports/historyPoints/filter": 466,
	"./customers/reports/historyPoints/filter.js": 466,
	"./customers/reports/historyPoints/table": 467,
	"./customers/reports/historyPoints/table.js": 467,
	"./customers/reports/logsUser": 1405,
	"./customers/reports/logsUser.js": 1405,
	"./customers/reports/logsUser/filter": 468,
	"./customers/reports/logsUser/filter.js": 468,
	"./customers/reports/logsUser/table": 469,
	"./customers/reports/logsUser/table.js": 469,
	"./customers/reports/loyaltyLevelChangeHistory": 1014,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1014,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 470,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 470,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 471,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 471,
	"./customers/reports/notesUser": 1406,
	"./customers/reports/notesUser.js": 1406,
	"./customers/reports/notesUser/filter": 472,
	"./customers/reports/notesUser/filter.js": 472,
	"./customers/reports/notesUser/table": 473,
	"./customers/reports/notesUser/table.js": 473,
	"./customers/reports/playerPrizesLoyalty": 1407,
	"./customers/reports/playerPrizesLoyalty.js": 1407,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 474,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 474,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 475,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 475,
	"./customers/reports/playerRoulette": 1408,
	"./customers/reports/playerRoulette.js": 1408,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 476,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 476,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 477,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 477,
	"./customers/reports/qualifyingPointsRecord": 1409,
	"./customers/reports/qualifyingPointsRecord.js": 1409,
	"./customers/reports/qualifyingPointsRecordReport/filter": 478,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 478,
	"./customers/reports/qualifyingPointsRecordReport/table": 479,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 479,
	"./customers/reports/referralsReport/filterReferralsReports": 458,
	"./customers/reports/referralsReport/filterReferralsReports.js": 458,
	"./customers/reports/referralsReport/recordReferralsReports": 1410,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1410,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1411,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1411,
	"./customers/reports/referralsReport/tableReferralsReports": 459,
	"./customers/reports/referralsReport/tableReferralsReports.js": 459,
	"./customers/reports/registeredDocument": 1412,
	"./customers/reports/registeredDocument.js": 1412,
	"./customers/reports/registeredDocuments/filter": 480,
	"./customers/reports/registeredDocuments/filter.js": 480,
	"./customers/reports/registeredDocuments/table": 481,
	"./customers/reports/registeredDocuments/table.js": 481,
	"./customers/reports/sessionsReport": 1413,
	"./customers/reports/sessionsReport.js": 1413,
	"./customers/reports/sessionsReport/detailsSessionsReport": 484,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 484,
	"./customers/reports/sessionsReport/filterSessionsReport": 482,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 482,
	"./customers/reports/sessionsReport/recordSessionsReport": 1015,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1015,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1016,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1016,
	"./customers/reports/sessionsReport/tableSessionsReport": 483,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 483,
	"./customers/reports/sessionsReport2": 1414,
	"./customers/reports/sessionsReport2.js": 1414,
	"./customers/reports/sessionsReport2/filter": 485,
	"./customers/reports/sessionsReport2/filter.js": 485,
	"./customers/reports/sessionsReport2/table": 486,
	"./customers/reports/sessionsReport2/table.js": 486,
	"./customers/reports/walletsReport": 1415,
	"./customers/reports/walletsReport.js": 1415,
	"./customers/reports/walletsReport/filter": 487,
	"./customers/reports/walletsReport/filter.js": 487,
	"./customers/reports/walletsReport/table": 488,
	"./customers/reports/walletsReport/table.js": 488,
	"./customers/reportscustomer": 1416,
	"./customers/reportscustomer.js": 1416,
	"./customers/statistics": 1417,
	"./customers/statistics.js": 1417,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1418,
	"./customersAggregator.js": 1418,
	"./customersAggregator/age": 1419,
	"./customersAggregator/age.js": 1419,
	"./customersAggregator/bonusReport": 1420,
	"./customersAggregator/bonusReport.js": 1420,
	"./customersAggregator/casinoGamesReport": 1421,
	"./customersAggregator/casinoGamesReport.js": 1421,
	"./customersAggregator/configuration": 1422,
	"./customersAggregator/configuration.js": 1422,
	"./customersAggregator/configuration/changePassword": 1423,
	"./customersAggregator/configuration/changePassword.js": 1423,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1424,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1424,
	"./customersAggregator/configuration/generateToken": 1425,
	"./customersAggregator/configuration/generateToken.js": 1425,
	"./customersAggregator/configuration/generateToken/filter": 1426,
	"./customersAggregator/configuration/generateToken/filter.js": 1426,
	"./customersAggregator/configuration/generateToken/table": 1427,
	"./customersAggregator/configuration/generateToken/table.js": 1427,
	"./customersAggregator/configuration/securityChanges": 1428,
	"./customersAggregator/configuration/securityChanges.js": 1428,
	"./customersAggregator/configuration/securityChanges/filter": 1429,
	"./customersAggregator/configuration/securityChanges/filter.js": 1429,
	"./customersAggregator/configuration/securityChanges/table": 1430,
	"./customersAggregator/configuration/securityChanges/table.js": 1430,
	"./customersAggregator/depositReport": 1431,
	"./customersAggregator/depositReport.js": 1431,
	"./customersAggregator/financescustomer": 1432,
	"./customersAggregator/financescustomer.js": 1432,
	"./customersAggregator/financial/bankAccounts": 1433,
	"./customersAggregator/financial/bankAccounts.js": 1433,
	"./customersAggregator/financial/bankAccounts/details": 1434,
	"./customersAggregator/financial/bankAccounts/details.js": 1434,
	"./customersAggregator/financial/bankAccounts/filter": 1435,
	"./customersAggregator/financial/bankAccounts/filter.js": 1435,
	"./customersAggregator/financial/bankAccounts/record": 1436,
	"./customersAggregator/financial/bankAccounts/record.js": 1436,
	"./customersAggregator/financial/bankAccounts/recordTable": 1437,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1437,
	"./customersAggregator/financial/bankAccounts/table": 1438,
	"./customersAggregator/financial/bankAccounts/table.js": 1438,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1439,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1439,
	"./customersAggregator/financial/informationFinancial": 1440,
	"./customersAggregator/financial/informationFinancial.js": 1440,
	"./customersAggregator/financial/withdrawalRequests": 1441,
	"./customersAggregator/financial/withdrawalRequests.js": 1441,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1442,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1442,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1443,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1443,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1444,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1444,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1445,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1445,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1446,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1446,
	"./customersAggregator/geo": 1447,
	"./customersAggregator/geo.js": 1447,
	"./customersAggregator/information": 1448,
	"./customersAggregator/information.js": 1448,
	"./customersAggregator/money": 1449,
	"./customersAggregator/money.js": 1449,
	"./customersAggregator/paymenthistory": 1450,
	"./customersAggregator/paymenthistory.js": 1450,
	"./customersAggregator/players/filter": 1451,
	"./customersAggregator/players/filter.js": 1451,
	"./customersAggregator/players/table": 1452,
	"./customersAggregator/players/table.js": 1452,
	"./customersAggregator/playersAggregator/filter": 1453,
	"./customersAggregator/playersAggregator/filter.js": 1453,
	"./customersAggregator/playersAggregator/table": 1454,
	"./customersAggregator/playersAggregator/table.js": 1454,
	"./customersAggregator/positions": 1455,
	"./customersAggregator/positions.js": 1455,
	"./customersAggregator/reports/autoexclusionUsers": 1456,
	"./customersAggregator/reports/autoexclusionUsers.js": 1456,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1457,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1457,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1458,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1458,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1459,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1459,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1460,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1460,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1461,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1461,
	"./customersAggregator/reports/betsReport": 1462,
	"./customersAggregator/reports/betsReport.js": 1462,
	"./customersAggregator/reports/betsReport/detailsReport": 1463,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1463,
	"./customersAggregator/reports/betsReport/filterReport": 1464,
	"./customersAggregator/reports/betsReport/filterReport.js": 1464,
	"./customersAggregator/reports/betsReport/recordReport": 1465,
	"./customersAggregator/reports/betsReport/recordReport.js": 1465,
	"./customersAggregator/reports/betsReport/recordTableReport": 1466,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1466,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1467,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1467,
	"./customersAggregator/reports/betsReport/recordTransReport": 1468,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1468,
	"./customersAggregator/reports/betsReport/tableReport": 1469,
	"./customersAggregator/reports/betsReport/tableReport.js": 1469,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1470,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1470,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1471,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1471,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1472,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1472,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1473,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1473,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1474,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1474,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1475,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1475,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1476,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1476,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1477,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1477,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1478,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1478,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1479,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1479,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1480,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1480,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1481,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1481,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1482,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1482,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1483,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1483,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1484,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1484,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1485,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1485,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1486,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1486,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1487,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1487,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1488,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1488,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1489,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1489,
	"./customersAggregator/reportscustomer": 1490,
	"./customersAggregator/reportscustomer.js": 1490,
	"./customersAggregator/statistics": 1491,
	"./customersAggregator/statistics.js": 1491,
	"./customersAggregator/tags": 1492,
	"./customersAggregator/tags.js": 1492,
	"./dashboard": 1493,
	"./dashboard.js": 1493,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 489,
	"./dates.js": 489,
	"./demos": 1494,
	"./demos.js": 1494,
	"./depositReport": 1495,
	"./depositReport.js": 1495,
	"./depositReport2": 1496,
	"./depositReport2.js": 1496,
	"./depositReport3": 1497,
	"./depositReport3.js": 1497,
	"./depositReportBetShop": 1498,
	"./depositReportBetShop.js": 1498,
	"./depositRequests": 1499,
	"./depositRequests.js": 1499,
	"./eliminateNoteWithdraw": 1500,
	"./eliminateNoteWithdraw.js": 1500,
	"./emailsReport": 1501,
	"./emailsReport.js": 1501,
	"./financial/depositRequests/filter": 498,
	"./financial/depositRequests/filter.js": 498,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 500,
	"./financial/depositRequests/recordTable.js": 500,
	"./financial/depositRequests/table": 499,
	"./financial/depositRequests/table.js": 499,
	"./financial/withdrawalRequests": 1502,
	"./financial/withdrawalRequests.js": 1502,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 507,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 507,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1503,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1503,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 508,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 508,
	"./flujoCaja": 1504,
	"./flujoCaja.js": 1504,
	"./franchisee": 1505,
	"./franchisee.js": 1505,
	"./franchises": 1506,
	"./franchises.js": 1506,
	"./futureEvents": 1507,
	"./futureEvents.js": 1507,
	"./gamePerformanceReport": 1508,
	"./gamePerformanceReport.js": 1508,
	"./getReportStructureGames": 1509,
	"./getReportStructureGames.js": 1509,
	"./goldenRace": 1510,
	"./goldenRace.js": 1510,
	"./historicalCashFlow": 1511,
	"./historicalCashFlow.js": 1511,
	"./historyMovement": 1512,
	"./historyMovement.js": 1512,
	"./historyMovement/filter": 1513,
	"./historyMovement/filter.js": 1513,
	"./historyMovement/table": 1514,
	"./historyMovement/table.js": 1514,
	"./historyMovementBetShop": 1515,
	"./historyMovementBetShop.js": 1515,
	"./historyPoints": 1516,
	"./historyPoints.js": 1516,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1517,
	"./information/recordTable.js": 1517,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1518,
	"./informationCasino.js": 1518,
	"./informationHipica": 1519,
	"./informationHipica.js": 1519,
	"./informationLiveCasino": 1520,
	"./informationLiveCasino.js": 1520,
	"./informationVirtual": 1521,
	"./informationVirtual.js": 1521,
	"./informeCasino": 1522,
	"./informeCasino.js": 1522,
	"./informeGerencial": 1523,
	"./informeGerencial.js": 1523,
	"./informeGerencial2": 1524,
	"./informeGerencial2.js": 1524,
	"./informeGerencialAgentes2": 1525,
	"./informeGerencialAgentes2.js": 1525,
	"./informeGerencialUsuarios2": 1526,
	"./informeGerencialUsuarios2.js": 1526,
	"./jackpotInternationalReport2": 1527,
	"./jackpotInternationalReport2.js": 1527,
	"./jackpotPaymentReports": 1528,
	"./jackpotPaymentReports.js": 1528,
	"./jackpotPaymentReports2": 1529,
	"./jackpotPaymentReports2.js": 1529,
	"./jackpotPrizeReport": 1530,
	"./jackpotPrizeReport.js": 1530,
	"./jackpotPrizeReportSportBet": 1531,
	"./jackpotPrizeReportSportBet.js": 1531,
	"./jackpotWinnersReport": 1532,
	"./jackpotWinnersReport.js": 1532,
	"./landingReport": 1533,
	"./landingReport.js": 1533,
	"./landingReport2": 1534,
	"./landingReport2.js": 1534,
	"./leagues/AddLeague": 1535,
	"./leagues/AddLeague.js": 1535,
	"./leagues/addLeagueManagement": 1536,
	"./leagues/addLeagueManagement.js": 1536,
	"./leagues/configuration": 1537,
	"./leagues/configuration.js": 1537,
	"./leagues/configuration/changePassword": 1538,
	"./leagues/configuration/changePassword.js": 1538,
	"./leagues/configuration/changePassword/changePasswordView": 1539,
	"./leagues/configuration/changePassword/changePasswordView.js": 1539,
	"./leagues/configuration/generateToken": 1540,
	"./leagues/configuration/generateToken.js": 1540,
	"./leagues/configuration/generateToken/filter": 1541,
	"./leagues/configuration/generateToken/filter.js": 1541,
	"./leagues/configuration/generateToken/table": 1542,
	"./leagues/configuration/generateToken/table.js": 1542,
	"./leagues/configuration/qrgoogle": 1543,
	"./leagues/configuration/qrgoogle.js": 1543,
	"./leagues/configuration/securityChanges": 1544,
	"./leagues/configuration/securityChanges.js": 1544,
	"./leagues/configuration/securityChanges/filter": 1545,
	"./leagues/configuration/securityChanges/filter.js": 1545,
	"./leagues/configuration/securityChanges/table": 1546,
	"./leagues/configuration/securityChanges/table.js": 1546,
	"./leagues/information": 1547,
	"./leagues/information.js": 1547,
	"./leagues/leagues-list/filter": 560,
	"./leagues/leagues-list/filter.js": 560,
	"./leagues/leagues-list/table": 561,
	"./leagues/leagues-list/table.js": 561,
	"./leagues/leaguesList": 1548,
	"./leagues/leaguesList.js": 1548,
	"./leagues/leaguesManagement": 1549,
	"./leagues/leaguesManagement.js": 1549,
	"./leagues/reports": 1550,
	"./leagues/reports.js": 1550,
	"./leagues/reports/betsReport": 1551,
	"./leagues/reports/betsReport.js": 1551,
	"./leagues/reports/betsReport/detailsReport": 1552,
	"./leagues/reports/betsReport/detailsReport.js": 1552,
	"./leagues/reports/betsReport/filterReport": 563,
	"./leagues/reports/betsReport/filterReport.js": 563,
	"./leagues/reports/betsReport/recordReport": 1553,
	"./leagues/reports/betsReport/recordReport.js": 1553,
	"./leagues/reports/betsReport/recordTableReport": 1554,
	"./leagues/reports/betsReport/recordTableReport.js": 1554,
	"./leagues/reports/betsReport/recordTableTransReport": 1555,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1555,
	"./leagues/reports/betsReport/recordTransReport": 565,
	"./leagues/reports/betsReport/recordTransReport.js": 565,
	"./leagues/reports/betsReport/tableReport": 564,
	"./leagues/reports/betsReport/tableReport.js": 564,
	"./leagues/reports/casinoGamesReport": 1556,
	"./leagues/reports/casinoGamesReport.js": 1556,
	"./leagues/reports/casinoReport/detailsCasinoReport": 568,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 568,
	"./leagues/reports/casinoReport/filterCasinoReport": 566,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 566,
	"./leagues/reports/casinoReport/recordCasinoReport": 569,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 569,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1557,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1557,
	"./leagues/reports/casinoReport/tableCasinoReport": 567,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 567,
	"./leagues/reports/userAfilliatesReport": 1558,
	"./leagues/reports/userAfilliatesReport.js": 1558,
	"./leagues/reports/user_affiliates/detailsReports": 1559,
	"./leagues/reports/user_affiliates/detailsReports.js": 1559,
	"./leagues/reports/user_affiliates/filterReports": 570,
	"./leagues/reports/user_affiliates/filterReports.js": 570,
	"./leagues/reports/user_affiliates/recordReports": 1560,
	"./leagues/reports/user_affiliates/recordReports.js": 1560,
	"./leagues/reports/user_affiliates/recordTableReports": 1561,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1561,
	"./leagues/reports/user_affiliates/tableReports": 571,
	"./leagues/reports/user_affiliates/tableReports.js": 571,
	"./leagues/results/recordTableResponts": 562,
	"./leagues/results/recordTableResponts.js": 562,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1562,
	"./leagues/statistics.js": 1562,
	"./leagues/statistics/age": 575,
	"./leagues/statistics/age.js": 575,
	"./leagues/statistics/marketing": 573,
	"./leagues/statistics/marketing.js": 573,
	"./leagues/statistics/marketingvsregistros": 574,
	"./leagues/statistics/marketingvsregistros.js": 574,
	"./leagues/statistics/money": 572,
	"./leagues/statistics/money.js": 572,
	"./limitationsReport": 1563,
	"./limitationsReport.js": 1563,
	"./loading": 1564,
	"./loading.js": 1564,
	"./login": 1565,
	"./login.js": 1565,
	"./logsUserGeneral": 1566,
	"./logsUserGeneral.js": 1566,
	"./loteryReport": 1567,
	"./loteryReport.js": 1567,
	"./loyaltyLevelChangeHistory": 1568,
	"./loyaltyLevelChangeHistory.js": 1568,
	"./machine/AddMachineRegister": 1569,
	"./machine/AddMachineRegister.js": 1569,
	"./machine/addMachineManagement": 1570,
	"./machine/addMachineManagement.js": 1570,
	"./machine/cashier/advertising": 585,
	"./machine/cashier/advertising.js": 585,
	"./machine/cashier/cashier": 1571,
	"./machine/cashier/cashier.js": 1571,
	"./machine/cashier/tableAdvertising": 586,
	"./machine/cashier/tableAdvertising.js": 586,
	"./machine/configuration": 1572,
	"./machine/configuration.js": 1572,
	"./machine/configuration/changePassword": 1573,
	"./machine/configuration/changePassword.js": 1573,
	"./machine/configuration/changePassword/changePasswordView": 1574,
	"./machine/configuration/changePassword/changePasswordView.js": 1574,
	"./machine/configuration/generateToken": 1575,
	"./machine/configuration/generateToken.js": 1575,
	"./machine/configuration/generateToken/filter": 1576,
	"./machine/configuration/generateToken/filter.js": 1576,
	"./machine/configuration/generateToken/table": 1577,
	"./machine/configuration/generateToken/table.js": 1577,
	"./machine/configuration/qrgoogle": 1578,
	"./machine/configuration/qrgoogle.js": 1578,
	"./machine/configuration/securityChanges": 1579,
	"./machine/configuration/securityChanges.js": 1579,
	"./machine/configuration/securityChanges/filter": 1020,
	"./machine/configuration/securityChanges/filter.js": 1020,
	"./machine/configuration/securityChanges/table": 587,
	"./machine/configuration/securityChanges/table.js": 587,
	"./machine/filter": 588,
	"./machine/filter.js": 588,
	"./machine/information": 1580,
	"./machine/information.js": 1580,
	"./machine/machineManagement": 1581,
	"./machine/machineManagement.js": 1581,
	"./machine/machineRegister": 1582,
	"./machine/machineRegister.js": 1582,
	"./machine/managePointsGraphics": 1583,
	"./machine/managePointsGraphics.js": 1583,
	"./machine/pagoNotaCobro": 1584,
	"./machine/pagoNotaCobro.js": 1584,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1021,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1021,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 592,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 592,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 593,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 593,
	"./machine/pagoPremioMaquina": 1585,
	"./machine/pagoPremioMaquina.js": 1585,
	"./machine/pagopremio/PagoPremio": 595,
	"./machine/pagopremio/PagoPremio.js": 595,
	"./machine/pagopremio/detailsPagoPremio": 597,
	"./machine/pagopremio/detailsPagoPremio.js": 597,
	"./machine/pagopremio/filterPagoPremio": 594,
	"./machine/pagopremio/filterPagoPremio.js": 594,
	"./machine/pagopremio/recordPagoPremio": 598,
	"./machine/pagopremio/recordPagoPremio.js": 598,
	"./machine/pagopremio/recordTablePagoPremio": 1586,
	"./machine/pagopremio/recordTablePagoPremio.js": 1586,
	"./machine/pagopremio/tablePagoPremio": 596,
	"./machine/pagopremio/tablePagoPremio.js": 596,
	"./machine/pointsGraphics/filter": 590,
	"./machine/pointsGraphics/filter.js": 590,
	"./machine/pointsGraphics/pointsList": 591,
	"./machine/pointsGraphics/pointsList.js": 591,
	"./machine/products2": 1587,
	"./machine/products2.js": 1587,
	"./machine/products2/categories-products/filter": 599,
	"./machine/products2/categories-products/filter.js": 599,
	"./machine/products2/categories-products/table": 600,
	"./machine/products2/categories-products/table.js": 600,
	"./machine/products2/categoriesProducts": 1588,
	"./machine/products2/categoriesProducts.js": 1588,
	"./machine/products2/partners-games/filter": 601,
	"./machine/products2/partners-games/filter.js": 601,
	"./machine/products2/partners-games/table": 602,
	"./machine/products2/partners-games/table.js": 602,
	"./machine/products2/partners-products/filter": 603,
	"./machine/products2/partners-products/filter.js": 603,
	"./machine/products2/partners-products/table": 604,
	"./machine/products2/partners-products/table.js": 604,
	"./machine/products2/partners-providers/filter": 605,
	"./machine/products2/partners-providers/filter.js": 605,
	"./machine/products2/partners-providers/table": 606,
	"./machine/products2/partners-providers/table.js": 606,
	"./machine/products2/partners-subProviders/filter": 607,
	"./machine/products2/partners-subProviders/filter.js": 607,
	"./machine/products2/partners-subProviders/table": 608,
	"./machine/products2/partners-subProviders/table.js": 608,
	"./machine/products2/partners-tipoproducto/filter": 609,
	"./machine/products2/partners-tipoproducto/filter.js": 609,
	"./machine/products2/partners-tipoproducto/table": 610,
	"./machine/products2/partners-tipoproducto/table.js": 610,
	"./machine/products2/partnersGames": 1589,
	"./machine/products2/partnersGames.js": 1589,
	"./machine/products2/partnersProducts": 1590,
	"./machine/products2/partnersProducts.js": 1590,
	"./machine/products2/partnersProviders": 1591,
	"./machine/products2/partnersProviders.js": 1591,
	"./machine/products2/partnersSubProviders": 1592,
	"./machine/products2/partnersSubProviders.js": 1592,
	"./machine/products2/partnersTypeProduct": 1593,
	"./machine/products2/partnersTypeProduct.js": 1593,
	"./machine/reports": 1594,
	"./machine/reports.js": 1594,
	"./machine/reports/betsReport": 1595,
	"./machine/reports/betsReport.js": 1595,
	"./machine/reports/betsReport/detailsReport": 1596,
	"./machine/reports/betsReport/detailsReport.js": 1596,
	"./machine/reports/betsReport/filterReport": 611,
	"./machine/reports/betsReport/filterReport.js": 611,
	"./machine/reports/betsReport/recordReport": 1597,
	"./machine/reports/betsReport/recordReport.js": 1597,
	"./machine/reports/betsReport/recordTableReport": 1598,
	"./machine/reports/betsReport/recordTableReport.js": 1598,
	"./machine/reports/betsReport/recordTableTransReport": 1599,
	"./machine/reports/betsReport/recordTableTransReport.js": 1599,
	"./machine/reports/betsReport/recordTransReport": 613,
	"./machine/reports/betsReport/recordTransReport.js": 613,
	"./machine/reports/betsReport/tableReport": 612,
	"./machine/reports/betsReport/tableReport.js": 612,
	"./machine/reports/casinoGamesReport": 1600,
	"./machine/reports/casinoGamesReport.js": 1600,
	"./machine/reports/casinoReport/detailsCasinoReport": 616,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 616,
	"./machine/reports/casinoReport/filterCasinoReport": 614,
	"./machine/reports/casinoReport/filterCasinoReport.js": 614,
	"./machine/reports/casinoReport/recordCasinoReport": 617,
	"./machine/reports/casinoReport/recordCasinoReport.js": 617,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1601,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1601,
	"./machine/reports/casinoReport/tableCasinoReport": 615,
	"./machine/reports/casinoReport/tableCasinoReport.js": 615,
	"./machine/reports/depositReport": 1602,
	"./machine/reports/depositReport.js": 1602,
	"./machine/reports/deposit_report/detailsDepositReports": 1022,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1022,
	"./machine/reports/deposit_report/filterDepositReports": 618,
	"./machine/reports/deposit_report/filterDepositReports.js": 618,
	"./machine/reports/deposit_report/recordDepositReports": 620,
	"./machine/reports/deposit_report/recordDepositReports.js": 620,
	"./machine/reports/deposit_report/recordTableDepositReports": 1603,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1603,
	"./machine/reports/deposit_report/tableDepositReports": 619,
	"./machine/reports/deposit_report/tableDepositReports.js": 619,
	"./machine/reports/flujoCaja": 1604,
	"./machine/reports/flujoCaja.js": 1604,
	"./machine/reports/flujocaja/detailsFlujoCaja": 623,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 623,
	"./machine/reports/flujocaja/filterFlujoCaja": 621,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 621,
	"./machine/reports/flujocaja/recordFlujoCaja": 624,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 624,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1605,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1605,
	"./machine/reports/flujocaja/tableFlujoCaja": 622,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 622,
	"./machine/reports/log/log": 625,
	"./machine/reports/log/log.js": 625,
	"./machine/reports/logReport": 1606,
	"./machine/reports/logReport.js": 1606,
	"./machine/reports/updates/filter": 626,
	"./machine/reports/updates/filter.js": 626,
	"./machine/reports/updates/table": 627,
	"./machine/reports/updates/table.js": 627,
	"./machine/reports/updatesReport": 1607,
	"./machine/reports/updatesReport.js": 1607,
	"./machine/reports/userAfilliatesReport": 1608,
	"./machine/reports/userAfilliatesReport.js": 1608,
	"./machine/reports/user_affiliates/detailsReports": 1609,
	"./machine/reports/user_affiliates/detailsReports.js": 1609,
	"./machine/reports/user_affiliates/filterReports": 628,
	"./machine/reports/user_affiliates/filterReports.js": 628,
	"./machine/reports/user_affiliates/recordReports": 1610,
	"./machine/reports/user_affiliates/recordReports.js": 1610,
	"./machine/reports/user_affiliates/recordTableReports": 1611,
	"./machine/reports/user_affiliates/recordTableReports.js": 1611,
	"./machine/reports/user_affiliates/tableReports": 629,
	"./machine/reports/user_affiliates/tableReports.js": 629,
	"./machine/reports/withdrawalRequests": 1612,
	"./machine/reports/withdrawalRequests.js": 1612,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 632,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 632,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 630,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 630,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1613,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1613,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 633,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 633,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 631,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 631,
	"./machine/results/recordTableResponts": 1614,
	"./machine/results/recordTableResponts.js": 1614,
	"./machine/results/tableResults": 1615,
	"./machine/results/tableResults.js": 1615,
	"./machine/statistics": 1616,
	"./machine/statistics.js": 1616,
	"./machine/statistics/age": 637,
	"./machine/statistics/age.js": 637,
	"./machine/statistics/marketing": 635,
	"./machine/statistics/marketing.js": 635,
	"./machine/statistics/marketingvsregistros": 636,
	"./machine/statistics/marketingvsregistros.js": 636,
	"./machine/statistics/money": 634,
	"./machine/statistics/money.js": 634,
	"./machine/table": 589,
	"./machine/table.js": 589,
	"./management/activateRegistration/filter": 201,
	"./management/activateRegistration/filter.js": 201,
	"./management/activateRegistration/response": 202,
	"./management/activateRegistration/response.js": 202,
	"./management/coupons/coupons": 439,
	"./management/coupons/coupons.js": 439,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 502,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 502,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 501,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 501,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 504,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 504,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 503,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 503,
	"./management/faltan.txt": 1946,
	"./management/managementClaims/filter": 638,
	"./management/managementClaims/filter.js": 638,
	"./management/managementClaims/table": 639,
	"./management/managementClaims/table.js": 639,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 640,
	"./management/managementContact/detailsTable.js": 640,
	"./management/managementContact/filterManagementContact": 641,
	"./management/managementContact/filterManagementContact.js": 641,
	"./management/managementContact/tableManagementContact": 642,
	"./management/managementContact/tableManagementContact.js": 642,
	"./management/managementContactUser/filter": 643,
	"./management/managementContactUser/filter.js": 643,
	"./management/managementContactUser/table": 644,
	"./management/managementContactUser/table.js": 644,
	"./management/managementGenericForms/filter": 645,
	"./management/managementGenericForms/filter.js": 645,
	"./management/managementGenericForms/table": 646,
	"./management/managementGenericForms/table.js": 646,
	"./management/quotaRetraction/Retraction": 647,
	"./management/quotaRetraction/Retraction.js": 647,
	"./management/quotaRetraction/search": 1023,
	"./management/quotaRetraction/search.js": 1023,
	"./management/registerFast/filterRegisterFast": 648,
	"./management/registerFast/filterRegisterFast.js": 648,
	"./management/registerFast/tableRegisterFast": 649,
	"./management/registerFast/tableRegisterFast.js": 649,
	"./management/reprintCheck/filterReprintCheck": 650,
	"./management/reprintCheck/filterReprintCheck.js": 650,
	"./management/reprintCheck/tableReprintCheck": 651,
	"./management/reprintCheck/tableReprintCheck.js": 651,
	"./management/restrictUser/filter": 652,
	"./management/restrictUser/filter.js": 652,
	"./management/restrictUser/table": 653,
	"./management/restrictUser/table.js": 653,
	"./management/reversionReload/filterReversionReload": 654,
	"./management/reversionReload/filterReversionReload.js": 654,
	"./management/reversionReload/tableReversionReload": 655,
	"./management/reversionReload/tableReversionReload.js": 655,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 656,
	"./management/usersVerification/informationJumio.js": 656,
	"./managementClaims": 1617,
	"./managementClaims.js": 1617,
	"./managementContact": 1618,
	"./managementContact.js": 1618,
	"./managementContactUser": 1619,
	"./managementContactUser.js": 1619,
	"./managementGenericForms": 1620,
	"./managementGenericForms.js": 1620,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1621,
	"./menuBonus.js": 1621,
	"./menuBuilder": 1622,
	"./menuBuilder.js": 1622,
	"./menuMarketing": 1623,
	"./menuMarketing.js": 1623,
	"./menus": 1624,
	"./menus.js": 1624,
	"./messages/bannerInvasive": 1625,
	"./messages/bannerInvasive.js": 1625,
	"./messages/bannerInvasive/filter": 659,
	"./messages/bannerInvasive/filter.js": 659,
	"./messages/bannerInvasive/table": 660,
	"./messages/bannerInvasive/table.js": 660,
	"./messages/fringe": 1626,
	"./messages/fringe.js": 1626,
	"./messages/fringe/filter": 661,
	"./messages/fringe/filter.js": 661,
	"./messages/fringe/table": 662,
	"./messages/fringe/table.js": 662,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 663,
	"./messages/messageInternAgent/filter.js": 663,
	"./messages/messageInternAgent/table": 664,
	"./messages/messageInternAgent/table.js": 664,
	"./messages/messageInternal": 1627,
	"./messages/messageInternal.js": 1627,
	"./messages/messageInternalAgent": 1628,
	"./messages/messageInternalAgent.js": 1628,
	"./messages/messageList": 1629,
	"./messages/messageList.js": 1629,
	"./messages/popup": 1630,
	"./messages/popup.js": 1630,
	"./messages/popup/filter": 665,
	"./messages/popup/filter.js": 665,
	"./messages/popup/table": 666,
	"./messages/popup/table.js": 666,
	"./messagesOld/messageIntern/filter": 1631,
	"./messagesOld/messageIntern/filter.js": 1631,
	"./messagesOld/messageIntern/table": 1632,
	"./messagesOld/messageIntern/table.js": 1632,
	"./messagesOld/messageList": 1633,
	"./messagesOld/messageList.js": 1633,
	"./myComissionsReport": 1634,
	"./myComissionsReport.js": 1634,
	"./myConfiguration/changeMyPassword": 1635,
	"./myConfiguration/changeMyPassword.js": 1635,
	"./myConfiguration/myInfoBetShop": 1636,
	"./myConfiguration/myInfoBetShop.js": 1636,
	"./myConfiguration/myInfoCustomer": 1637,
	"./myConfiguration/myInfoCustomer.js": 1637,
	"./myConfiguration/myInformation": 1638,
	"./myConfiguration/myInformation.js": 1638,
	"./myConfiguration/qrgoogle": 1639,
	"./myConfiguration/qrgoogle.js": 1639,
	"./notesUser": 1640,
	"./notesUser.js": 1640,
	"./notifications": 994,
	"./notifications.js": 994,
	"./operatorResponsibility": 1641,
	"./operatorResponsibility.js": 1641,
	"./ownersIncome": 1642,
	"./ownersIncome.js": 1642,
	"./ownersIncomeSecondLevel": 1643,
	"./ownersIncomeSecondLevel.js": 1643,
	"./pagoNotaRetiro": 1644,
	"./pagoNotaRetiro.js": 1644,
	"./pagoPremio": 1645,
	"./pagoPremio.js": 1645,
	"./pagoPremioVirtuales": 1646,
	"./pagoPremioVirtuales.js": 1646,
	"./paidPendingAwards": 1647,
	"./paidPendingAwards.js": 1647,
	"./partner/PartnerSettings": 1648,
	"./partner/PartnerSettings.js": 1648,
	"./partner/PartnerSettingsOld": 1649,
	"./partner/PartnerSettingsOld.js": 1649,
	"./partner/TRM": 1650,
	"./partner/TRM.js": 1650,
	"./partner/TRM/filter": 681,
	"./partner/TRM/filter.js": 681,
	"./partner/TRM/table": 682,
	"./partner/TRM/table.js": 682,
	"./partner/configuration": 1651,
	"./partner/configuration.js": 1651,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1652,
	"./partner/configurationControl.js": 1652,
	"./partner/configurationControl/filter": 683,
	"./partner/configurationControl/filter.js": 683,
	"./partner/configurationControl/table": 684,
	"./partner/configurationControl/table.js": 684,
	"./partner/configurationControl2": 1653,
	"./partner/configurationControl2.js": 1653,
	"./partner/configurationControl2/filter": 685,
	"./partner/configurationControl2/filter.js": 685,
	"./partner/configurationControl2/table": 686,
	"./partner/configurationControl2/table.js": 686,
	"./partner/configurationOld/filter": 1654,
	"./partner/configurationOld/filter.js": 1654,
	"./partner/configurationOld/settings": 1655,
	"./partner/configurationOld/settings.js": 1655,
	"./partner/configurationSEO": 1656,
	"./partner/configurationSEO.js": 1656,
	"./partner/configurationSEO/filter": 687,
	"./partner/configurationSEO/filter.js": 687,
	"./partner/configurationSEO/settings": 688,
	"./partner/configurationSEO/settings.js": 688,
	"./partner/countries": 1657,
	"./partner/countries.js": 1657,
	"./partner/countries/countries": 689,
	"./partner/countries/countries.js": 689,
	"./partner/menusUser": 1658,
	"./partner/menusUser.js": 1658,
	"./partner/menusUser/filter": 690,
	"./partner/menusUser/filter.js": 690,
	"./partner/menusUser/table": 691,
	"./partner/menusUser/table.js": 691,
	"./partner/partner-list/filter": 679,
	"./partner/partner-list/filter.js": 679,
	"./partner/partner-list/table": 680,
	"./partner/partner-list/table.js": 680,
	"./partner/partnertManagement": 1659,
	"./partner/partnertManagement.js": 1659,
	"./partner/products": 1660,
	"./partner/products.js": 1660,
	"./partner/products/categories-products/filter": 692,
	"./partner/products/categories-products/filter.js": 692,
	"./partner/products/categories-products/table": 693,
	"./partner/products/categories-products/table.js": 693,
	"./partner/products/categoriesProducts": 1661,
	"./partner/products/categoriesProducts.js": 1661,
	"./partner/products/partners-products/filter": 694,
	"./partner/products/partners-products/filter.js": 694,
	"./partner/products/partners-products/table": 695,
	"./partner/products/partners-products/table.js": 695,
	"./partner/products/partners-providers/filter": 696,
	"./partner/products/partners-providers/filter.js": 696,
	"./partner/products/partners-providers/table": 697,
	"./partner/products/partners-providers/table.js": 697,
	"./partner/products/partners-subProviders/filter": 698,
	"./partner/products/partners-subProviders/filter.js": 698,
	"./partner/products/partners-subProviders/table": 699,
	"./partner/products/partners-subProviders/table.js": 699,
	"./partner/products/partners-tipoproducto/filter": 700,
	"./partner/products/partners-tipoproducto/filter.js": 700,
	"./partner/products/partners-tipoproducto/table": 701,
	"./partner/products/partners-tipoproducto/table.js": 701,
	"./partner/products/partnersProducts": 1662,
	"./partner/products/partnersProducts.js": 1662,
	"./partner/products/partnersProviders": 1663,
	"./partner/products/partnersProviders.js": 1663,
	"./partner/products/partnersSubProviders": 1664,
	"./partner/products/partnersSubProviders.js": 1664,
	"./partner/products/partnersTypeProduct": 1665,
	"./partner/products/partnersTypeProduct.js": 1665,
	"./partner/products/products-banks/filter": 702,
	"./partner/products/products-banks/filter.js": 702,
	"./partner/products/products-banks/table": 703,
	"./partner/products/products-banks/table.js": 703,
	"./partner/products/products-cryptoNetwork/filter": 704,
	"./partner/products/products-cryptoNetwork/filter.js": 704,
	"./partner/products/products-cryptoNetwork/table": 705,
	"./partner/products/products-cryptoNetwork/table.js": 705,
	"./partner/products/products-franchises/filter": 706,
	"./partner/products/products-franchises/filter.js": 706,
	"./partner/products/products-franchises/table": 707,
	"./partner/products/products-franchises/table.js": 707,
	"./partner/products/productsBanks": 1666,
	"./partner/products/productsBanks.js": 1666,
	"./partner/products/productsCryptoNetwork": 1667,
	"./partner/products/productsCryptoNetwork.js": 1667,
	"./partner/products/productsFranchises": 1668,
	"./partner/products/productsFranchises.js": 1668,
	"./partner/products2": 1669,
	"./partner/products2.js": 1669,
	"./partner/products2/banks-partners/filter": 708,
	"./partner/products2/banks-partners/filter.js": 708,
	"./partner/products2/banks-partners/table": 709,
	"./partner/products2/banks-partners/table.js": 709,
	"./partner/products2/categories-products/filter": 710,
	"./partner/products2/categories-products/filter.js": 710,
	"./partner/products2/categories-products/table": 711,
	"./partner/products2/categories-products/table.js": 711,
	"./partner/products2/categoriesProducts": 1670,
	"./partner/products2/categoriesProducts.js": 1670,
	"./partner/products2/enablement-products/filter": 712,
	"./partner/products2/enablement-products/filter.js": 712,
	"./partner/products2/enablement-products/table": 713,
	"./partner/products2/enablement-products/table.js": 713,
	"./partner/products2/enablementProducts": 1671,
	"./partner/products2/enablementProducts.js": 1671,
	"./partner/products2/franchises-partner/filter": 714,
	"./partner/products2/franchises-partner/filter.js": 714,
	"./partner/products2/franchises-partner/table": 715,
	"./partner/products2/franchises-partner/table.js": 715,
	"./partner/products2/partners-categories/filter": 716,
	"./partner/products2/partners-categories/filter.js": 716,
	"./partner/products2/partners-categories/table": 717,
	"./partner/products2/partners-categories/table.js": 717,
	"./partner/products2/partners-credentialsSubProviders/filter": 718,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 718,
	"./partner/products2/partners-credentialsSubProviders/table": 719,
	"./partner/products2/partners-credentialsSubProviders/table.js": 719,
	"./partner/products2/partners-games/filter": 720,
	"./partner/products2/partners-games/filter.js": 720,
	"./partner/products2/partners-games/table": 721,
	"./partner/products2/partners-games/table.js": 721,
	"./partner/products2/partners-products/filter": 722,
	"./partner/products2/partners-products/filter.js": 722,
	"./partner/products2/partners-products/table": 723,
	"./partner/products2/partners-products/table.js": 723,
	"./partner/products2/partners-providers-order/filter": 1672,
	"./partner/products2/partners-providers-order/filter.js": 1672,
	"./partner/products2/partners-providers-order/table": 1673,
	"./partner/products2/partners-providers-order/table.js": 1673,
	"./partner/products2/partners-providers/filter": 724,
	"./partner/products2/partners-providers/filter.js": 724,
	"./partner/products2/partners-providers/table": 725,
	"./partner/products2/partners-providers/table.js": 725,
	"./partner/products2/partners-subProviders-order/filter": 726,
	"./partner/products2/partners-subProviders-order/filter.js": 726,
	"./partner/products2/partners-subProviders-order/table": 727,
	"./partner/products2/partners-subProviders-order/table.js": 727,
	"./partner/products2/partners-subProviders/filter": 728,
	"./partner/products2/partners-subProviders/filter.js": 728,
	"./partner/products2/partners-subProviders/table": 729,
	"./partner/products2/partners-subProviders/table.js": 729,
	"./partner/products2/partners-tipoproducto/filter": 730,
	"./partner/products2/partners-tipoproducto/filter.js": 730,
	"./partner/products2/partners-tipoproducto/table": 731,
	"./partner/products2/partners-tipoproducto/table.js": 731,
	"./partner/products2/partnersBanks": 1674,
	"./partner/products2/partnersBanks.js": 1674,
	"./partner/products2/partnersCategories": 1675,
	"./partner/products2/partnersCategories.js": 1675,
	"./partner/products2/partnersCredentialsSubProviders": 1676,
	"./partner/products2/partnersCredentialsSubProviders.js": 1676,
	"./partner/products2/partnersFranchises": 1677,
	"./partner/products2/partnersFranchises.js": 1677,
	"./partner/products2/partnersGames": 1678,
	"./partner/products2/partnersGames.js": 1678,
	"./partner/products2/partnersProducts": 1679,
	"./partner/products2/partnersProducts.js": 1679,
	"./partner/products2/partnersProviders": 1680,
	"./partner/products2/partnersProviders.js": 1680,
	"./partner/products2/partnersSubProviders": 1681,
	"./partner/products2/partnersSubProviders.js": 1681,
	"./partner/products2/partnersSubProvidersOrder": 1682,
	"./partner/products2/partnersSubProvidersOrder.js": 1682,
	"./partner/products2/partnersTypeProduct": 1683,
	"./partner/products2/partnersTypeProduct.js": 1683,
	"./partner/reports": 1684,
	"./partner/reports.js": 1684,
	"./partner/reports/autoexclusionUsers": 1685,
	"./partner/reports/autoexclusionUsers.js": 1685,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 734,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 734,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 732,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 732,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1024,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1024,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 735,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 735,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 733,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 733,
	"./partner/reports/balanceAdjustments": 1686,
	"./partner/reports/balanceAdjustments.js": 1686,
	"./partner/reports/balanceAdjustments/filter": 736,
	"./partner/reports/balanceAdjustments/filter.js": 736,
	"./partner/reports/balanceAdjustments/table": 737,
	"./partner/reports/balanceAdjustments/table.js": 737,
	"./partner/reports/balanceHistory": 1687,
	"./partner/reports/balanceHistory.js": 1687,
	"./partner/reports/balanceHistory/filter": 738,
	"./partner/reports/balanceHistory/filter.js": 738,
	"./partner/reports/balanceHistory/table": 739,
	"./partner/reports/balanceHistory/table.js": 739,
	"./partner/reports/balanceHistoryBetShop": 1688,
	"./partner/reports/balanceHistoryBetShop.js": 1688,
	"./partner/reports/balanceHistoryBetShop/filter": 740,
	"./partner/reports/balanceHistoryBetShop/filter.js": 740,
	"./partner/reports/balanceHistoryBetShop/table": 741,
	"./partner/reports/balanceHistoryBetShop/table.js": 741,
	"./partner/reports/balanceUsers": 1689,
	"./partner/reports/balanceUsers.js": 1689,
	"./partner/reports/balanceUsers/filter": 742,
	"./partner/reports/balanceUsers/filter.js": 742,
	"./partner/reports/balanceUsers/record": 744,
	"./partner/reports/balanceUsers/record.js": 744,
	"./partner/reports/balanceUsers/resume": 745,
	"./partner/reports/balanceUsers/resume.js": 745,
	"./partner/reports/balanceUsers/table": 743,
	"./partner/reports/balanceUsers/table.js": 743,
	"./partner/reports/betsReport": 1690,
	"./partner/reports/betsReport.js": 1690,
	"./partner/reports/betsReport/detailsReport": 1691,
	"./partner/reports/betsReport/detailsReport.js": 1691,
	"./partner/reports/betsReport/filterReport": 746,
	"./partner/reports/betsReport/filterReport.js": 746,
	"./partner/reports/betsReport/recordReport": 750,
	"./partner/reports/betsReport/recordReport.js": 750,
	"./partner/reports/betsReport/recordTableReport": 751,
	"./partner/reports/betsReport/recordTableReport.js": 751,
	"./partner/reports/betsReport/recordTableTransReport": 749,
	"./partner/reports/betsReport/recordTableTransReport.js": 749,
	"./partner/reports/betsReport/recordTransReport": 748,
	"./partner/reports/betsReport/recordTransReport.js": 748,
	"./partner/reports/betsReport/tableReport": 747,
	"./partner/reports/betsReport/tableReport.js": 747,
	"./partner/reports/bonusReport": 1692,
	"./partner/reports/bonusReport.js": 1692,
	"./partner/reports/bonusReport/detailsBonusReport": 754,
	"./partner/reports/bonusReport/detailsBonusReport.js": 754,
	"./partner/reports/bonusReport/filterBonusReport": 752,
	"./partner/reports/bonusReport/filterBonusReport.js": 752,
	"./partner/reports/bonusReport/recordBonusReport": 755,
	"./partner/reports/bonusReport/recordBonusReport.js": 755,
	"./partner/reports/bonusReport/recordTableBonusReport": 756,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 756,
	"./partner/reports/bonusReport/tableBonusReport": 753,
	"./partner/reports/bonusReport/tableBonusReport.js": 753,
	"./partner/reports/casinoGamesReport": 1693,
	"./partner/reports/casinoGamesReport.js": 1693,
	"./partner/reports/casinoReport/detailsCasinoReport": 759,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 759,
	"./partner/reports/casinoReport/filterCasinoReport": 757,
	"./partner/reports/casinoReport/filterCasinoReport.js": 757,
	"./partner/reports/casinoReport/recordCasinoReport": 760,
	"./partner/reports/casinoReport/recordCasinoReport.js": 760,
	"./partner/reports/casinoReport/recordTableCasinoReport": 761,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 761,
	"./partner/reports/casinoReport/tableCasinoReport": 758,
	"./partner/reports/casinoReport/tableCasinoReport.js": 758,
	"./partner/reports/comissionsReport": 1694,
	"./partner/reports/comissionsReport.js": 1694,
	"./partner/reports/comissions_report/filter": 762,
	"./partner/reports/comissions_report/filter.js": 762,
	"./partner/reports/comissions_report/table": 763,
	"./partner/reports/comissions_report/table.js": 763,
	"./partner/reports/depositReport": 1695,
	"./partner/reports/depositReport.js": 1695,
	"./partner/reports/deposit_report/detailsDepositReports": 1025,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1025,
	"./partner/reports/deposit_report/filterDepositReports": 764,
	"./partner/reports/deposit_report/filterDepositReports.js": 764,
	"./partner/reports/deposit_report/recordDepositReports": 766,
	"./partner/reports/deposit_report/recordDepositReports.js": 766,
	"./partner/reports/deposit_report/recordTableDepositReports": 767,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 767,
	"./partner/reports/deposit_report/tableDepositReports": 765,
	"./partner/reports/deposit_report/tableDepositReports.js": 765,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 768,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 768,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 769,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 769,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 770,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 770,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 771,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 771,
	"./partner/reports/historicalCashFlow": 1696,
	"./partner/reports/historicalCashFlow.js": 1696,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 774,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 774,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 772,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 772,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 775,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 775,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 776,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 776,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 773,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 773,
	"./partner/reports/historyMovement": 1697,
	"./partner/reports/historyMovement.js": 1697,
	"./partner/reports/historyMovement/filter": 777,
	"./partner/reports/historyMovement/filter.js": 777,
	"./partner/reports/historyMovement/table": 778,
	"./partner/reports/historyMovement/table.js": 778,
	"./partner/reports/informeCasino/detailsInformeCasino": 1698,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1698,
	"./partner/reports/informeCasino/filterInformeCasino": 1699,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1699,
	"./partner/reports/informeCasino/recordInformeCasino": 1700,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1700,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1701,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1701,
	"./partner/reports/informeCasino/tableInformeCasino": 1702,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1702,
	"./partner/reports/informeGerencial": 1703,
	"./partner/reports/informeGerencial.js": 1703,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 781,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 781,
	"./partner/reports/informeGerencial/filterInformeGerencial": 779,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 779,
	"./partner/reports/informeGerencial/recordInformeGerencial": 782,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 782,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 783,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 783,
	"./partner/reports/informeGerencial/tableInformeGerencial": 780,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 780,
	"./partner/reports/landingReport/detailsLandingReport": 1704,
	"./partner/reports/landingReport/detailsLandingReport.js": 1704,
	"./partner/reports/landingReport/filterLandingReport": 1705,
	"./partner/reports/landingReport/filterLandingReport.js": 1705,
	"./partner/reports/landingReport/recordLandingReport": 1706,
	"./partner/reports/landingReport/recordLandingReport.js": 1706,
	"./partner/reports/landingReport/recordTableLandingReport": 1707,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1707,
	"./partner/reports/landingReport/tableLandingReport": 1708,
	"./partner/reports/landingReport/tableLandingReport.js": 1708,
	"./partner/reports/logsUser/filter": 1709,
	"./partner/reports/logsUser/filter.js": 1709,
	"./partner/reports/logsUser/table": 1710,
	"./partner/reports/logsUser/table.js": 1710,
	"./partner/reports/operatorResponsibility/filter": 1711,
	"./partner/reports/operatorResponsibility/filter.js": 1711,
	"./partner/reports/operatorResponsibility/table": 1712,
	"./partner/reports/operatorResponsibility/table.js": 1712,
	"./partner/reports/paidPendingAwards": 1713,
	"./partner/reports/paidPendingAwards.js": 1713,
	"./partner/reports/playersReport/detailsPlayersReport": 1714,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1714,
	"./partner/reports/playersReport/filterPlayersReport": 1715,
	"./partner/reports/playersReport/filterPlayersReport.js": 1715,
	"./partner/reports/playersReport/recordPlayersReport": 1716,
	"./partner/reports/playersReport/recordPlayersReport.js": 1716,
	"./partner/reports/playersReport/recordTablePlayersReport": 787,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 787,
	"./partner/reports/playersReport/tablePlayersReport": 1717,
	"./partner/reports/playersReport/tablePlayersReport.js": 1717,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1026,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1026,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 784,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 784,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1027,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1027,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 786,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 786,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 785,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 785,
	"./partner/reports/promotionalCodes/filter": 1718,
	"./partner/reports/promotionalCodes/filter.js": 1718,
	"./partner/reports/promotionalCodes/table": 1719,
	"./partner/reports/promotionalCodes/table.js": 1719,
	"./partner/reports/quotaRetraction/filter": 1720,
	"./partner/reports/quotaRetraction/filter.js": 1720,
	"./partner/reports/quotaRetraction/table": 1721,
	"./partner/reports/quotaRetraction/table.js": 1721,
	"./partner/reports/registeredDocument": 1722,
	"./partner/reports/registeredDocument.js": 1722,
	"./partner/reports/registeredDocuments/filter": 788,
	"./partner/reports/registeredDocuments/filter.js": 788,
	"./partner/reports/registeredDocuments/table": 789,
	"./partner/reports/registeredDocuments/table.js": 789,
	"./partner/reports/relationUserAggregator": 1723,
	"./partner/reports/relationUserAggregator.js": 1723,
	"./partner/reports/relationUserAggregator/filter": 790,
	"./partner/reports/relationUserAggregator/filter.js": 790,
	"./partner/reports/relationUserAggregator/table": 791,
	"./partner/reports/relationUserAggregator/table.js": 791,
	"./partner/reports/reportHash/filter": 1724,
	"./partner/reports/reportHash/filter.js": 1724,
	"./partner/reports/reportHash/table": 1725,
	"./partner/reports/reportHash/table.js": 1725,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1726,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1726,
	"./partner/reports/sessionsReport/filterSessionsReport": 1727,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1727,
	"./partner/reports/sessionsReport/recordSessionsReport": 1728,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1728,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1028,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1028,
	"./partner/reports/sessionsReport/tableSessionsReport": 1729,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1729,
	"./partner/reports/sportsTransactions": 1730,
	"./partner/reports/sportsTransactions.js": 1730,
	"./partner/reports/sportsTransactions/filter": 792,
	"./partner/reports/sportsTransactions/filter.js": 792,
	"./partner/reports/sportsTransactions/table": 793,
	"./partner/reports/sportsTransactions/table.js": 793,
	"./partner/reports/summaryCashFlow": 1731,
	"./partner/reports/summaryCashFlow.js": 1731,
	"./partner/reports/taxableEarnings/filter": 1732,
	"./partner/reports/taxableEarnings/filter.js": 1732,
	"./partner/reports/taxableEarnings/table": 1733,
	"./partner/reports/taxableEarnings/table.js": 1733,
	"./partner/reports/transfersReport/filter": 1734,
	"./partner/reports/transfersReport/filter.js": 1734,
	"./partner/reports/transfersReport/table": 1735,
	"./partner/reports/transfersReport/table.js": 1735,
	"./partner/reports/usuarioOnlineResumido": 1736,
	"./partner/reports/usuarioOnlineResumido.js": 1736,
	"./partner/reports/usuarioOnlineResumido/filter": 794,
	"./partner/reports/usuarioOnlineResumido/filter.js": 794,
	"./partner/reports/usuarioOnlineResumido/table": 795,
	"./partner/reports/usuarioOnlineResumido/table.js": 795,
	"./partner/reports/wallets": 1737,
	"./partner/reports/wallets.js": 1737,
	"./partner/reports/wallets/filter": 796,
	"./partner/reports/wallets/filter.js": 796,
	"./partner/reports/wallets/table": 797,
	"./partner/reports/wallets/table.js": 797,
	"./partner/templates": 1738,
	"./partner/templates.js": 1738,
	"./partner/templates/email": 1739,
	"./partner/templates/email.js": 1739,
	"./partner/templates/email/filter": 798,
	"./partner/templates/email/filter.js": 798,
	"./partner/templates/email/table": 799,
	"./partner/templates/email/table.js": 799,
	"./partner/templates/email/template": 800,
	"./partner/templates/email/template.js": 800,
	"./partner/templates/emailTemplate": 1740,
	"./partner/templates/emailTemplate.js": 1740,
	"./partner/templates/pdf": 1741,
	"./partner/templates/pdf.js": 1741,
	"./partner/templates/pdf/filter": 801,
	"./partner/templates/pdf/filter.js": 801,
	"./partner/templates/pdf/table": 802,
	"./partner/templates/pdf/table.js": 802,
	"./partner/templates/pdf/template": 803,
	"./partner/templates/pdf/template.js": 803,
	"./partner/templates/pdfTemplate": 1742,
	"./partner/templates/pdfTemplate.js": 1742,
	"./partner/templates/sms": 1743,
	"./partner/templates/sms.js": 1743,
	"./partner/templates/sms/filter": 804,
	"./partner/templates/sms/filter.js": 804,
	"./partner/templates/sms/table": 805,
	"./partner/templates/sms/table.js": 805,
	"./partner/templates/sms/template": 806,
	"./partner/templates/sms/template.js": 806,
	"./partner/templates/smsTemplate": 1744,
	"./partner/templates/smsTemplate.js": 1744,
	"./partners": 1745,
	"./partners.js": 1745,
	"./partnersCategories": 1746,
	"./partnersCategories.js": 1746,
	"./partnersProducts": 1747,
	"./partnersProducts.js": 1747,
	"./partnersProductsCountry": 1748,
	"./partnersProductsCountry.js": 1748,
	"./partnersProviders": 1749,
	"./partnersProviders.js": 1749,
	"./partnersTypeProduct": 1750,
	"./partnersTypeProduct.js": 1750,
	"./payPrizesLoyalty": 1751,
	"./payPrizesLoyalty.js": 1751,
	"./payhistoryview": 1752,
	"./payhistoryview.js": 1752,
	"./platformSpecific": 1753,
	"./platformSpecific.js": 1753,
	"./platformSpecific2": 1754,
	"./platformSpecific2.js": 1754,
	"./playerAccount": 1755,
	"./playerAccount.js": 1755,
	"./playerAccount2": 1756,
	"./playerAccount2.js": 1756,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1757,
	"./playersList.js": 1757,
	"./playersList2": 1758,
	"./playersList2.js": 1758,
	"./playersListAggregator": 1759,
	"./playersListAggregator.js": 1759,
	"./playersLists": 1760,
	"./playersLists.js": 1760,
	"./playersReport": 1761,
	"./playersReport.js": 1761,
	"./pointSettings": 1762,
	"./pointSettings.js": 1762,
	"./pointsUsers": 1763,
	"./pointsUsers.js": 1763,
	"./pokerReport": 1764,
	"./pokerReport.js": 1764,
	"./prices": 1765,
	"./prices.js": 1765,
	"./prizesLoyalty": 1766,
	"./prizesLoyalty.js": 1766,
	"./products": 1767,
	"./products.js": 1767,
	"./products/activeProviders/filterActiveProviders": 203,
	"./products/activeProviders/filterActiveProviders.js": 203,
	"./products/activeProviders/tableActiveProviders": 204,
	"./products/activeProviders/tableActiveProviders.js": 204,
	"./products/banks/filterBanks": 321,
	"./products/banks/filterBanks.js": 321,
	"./products/banks/tableBanks": 322,
	"./products/banks/tableBanks.js": 322,
	"./products/blockchain-networks/filterBlockchainNetworks": 377,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 377,
	"./products/blockchain-networks/tableBlockchainNetworks": 378,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 378,
	"./products/categories-products/detailsCategoriesProducts": 1011,
	"./products/categories-products/detailsCategoriesProducts.js": 1011,
	"./products/categories-products/filterCategoriesProducts": 420,
	"./products/categories-products/filterCategoriesProducts.js": 420,
	"./products/categories-products/recordCategoriesProducts": 1012,
	"./products/categories-products/recordCategoriesProducts.js": 1012,
	"./products/categories-products/recordTableCategoriesProducts": 422,
	"./products/categories-products/recordTableCategoriesProducts.js": 422,
	"./products/categories-products/tableCategoriesProducts": 421,
	"./products/categories-products/tableCategoriesProducts.js": 421,
	"./products/categories/detailsCategories": 1009,
	"./products/categories/detailsCategories.js": 1009,
	"./products/categories/filterCategories": 417,
	"./products/categories/filterCategories.js": 417,
	"./products/categories/recordCategories": 1010,
	"./products/categories/recordCategories.js": 1010,
	"./products/categories/recordTableCategories": 419,
	"./products/categories/recordTableCategories.js": 419,
	"./products/categories/tableCategories": 418,
	"./products/categories/tableCategories.js": 418,
	"./products/crypto-blockchain/filterCryptoBlockchain": 442,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 442,
	"./products/crypto-blockchain/tableCryptoBlockchain": 443,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 443,
	"./products/cryptos/filterCrypto": 444,
	"./products/cryptos/filterCrypto.js": 444,
	"./products/cryptos/tableCrypto": 445,
	"./products/cryptos/tableCrypto.js": 445,
	"./products/franchises/filterFranchises": 511,
	"./products/franchises/filterFranchises.js": 511,
	"./products/franchises/tableFranchises": 512,
	"./products/franchises/tableFranchises.js": 512,
	"./products/partners-products-country/detailsPartnersProductsCountry": 817,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 817,
	"./products/partners-products-country/filterPartnersProductsCountry": 815,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 815,
	"./products/partners-products-country/recordPartnersProductsCountry": 818,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 818,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 819,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 819,
	"./products/partners-products-country/tablePartnersProductsCountry": 816,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 816,
	"./products/partners-products/detailsPartnersProducts": 813,
	"./products/partners-products/detailsPartnersProducts.js": 813,
	"./products/partners-products/filterPartnersProducts": 811,
	"./products/partners-products/filterPartnersProducts.js": 811,
	"./products/partners-products/recordPartnersProducts": 814,
	"./products/partners-products/recordPartnersProducts.js": 814,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 812,
	"./products/partners-products/tablePartnersProducts.js": 812,
	"./products/partners-providers/details": 822,
	"./products/partners-providers/details.js": 822,
	"./products/partners-providers/filter": 820,
	"./products/partners-providers/filter.js": 820,
	"./products/partners-providers/record": 823,
	"./products/partners-providers/record.js": 823,
	"./products/partners-providers/recordTable": 1768,
	"./products/partners-providers/recordTable.js": 1768,
	"./products/partners-providers/table": 821,
	"./products/partners-providers/table.js": 821,
	"./products/partners-tipoproducto/details": 826,
	"./products/partners-tipoproducto/details.js": 826,
	"./products/partners-tipoproducto/filter": 824,
	"./products/partners-tipoproducto/filter.js": 824,
	"./products/partners-tipoproducto/record": 827,
	"./products/partners-tipoproducto/record.js": 827,
	"./products/partners-tipoproducto/recordTable": 1769,
	"./products/partners-tipoproducto/recordTable.js": 1769,
	"./products/partners-tipoproducto/table": 825,
	"./products/partners-tipoproducto/table.js": 825,
	"./products/partners/filter": 807,
	"./products/partners/filter.js": 807,
	"./products/partners/table": 808,
	"./products/partners/table.js": 808,
	"./products/products/detailsProducts": 1029,
	"./products/products/detailsProducts.js": 1029,
	"./products/products/filterProducts": 849,
	"./products/products/filterProducts.js": 849,
	"./products/products/recordProducts": 1030,
	"./products/products/recordProducts.js": 1030,
	"./products/products/recordTableProducts": 851,
	"./products/products/recordTableProducts.js": 851,
	"./products/products/tableProducts": 850,
	"./products/products/tableProducts.js": 850,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 852,
	"./products/providers/filterProviders.js": 852,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 323,
	"./products/providers/recordTableProviders.js": 323,
	"./products/providers/tableProviders": 853,
	"./products/providers/tableProviders.js": 853,
	"./products/subProviders/filter": 854,
	"./products/subProviders/filter.js": 854,
	"./products/subProviders/table": 855,
	"./products/subProviders/table.js": 855,
	"./products/tags/detailsTags": 1031,
	"./products/tags/detailsTags.js": 1031,
	"./products/tags/filterTags": 856,
	"./products/tags/filterTags.js": 856,
	"./products/tags/recordTableTags": 857,
	"./products/tags/recordTableTags.js": 857,
	"./products/tags/recordTags": 1032,
	"./products/tags/recordTags.js": 1032,
	"./products/tags/tableTags": 858,
	"./products/tags/tableTags.js": 858,
	"./profile": 1770,
	"./profile.js": 1770,
	"./profileOptions": 1771,
	"./profileOptions.js": 1771,
	"./profileOptions2": 1772,
	"./profileOptions2.js": 1772,
	"./profileOptionsOld": 1773,
	"./profileOptionsOld.js": 1773,
	"./promotionalCasinoCampaings": 1774,
	"./promotionalCasinoCampaings.js": 1774,
	"./promotionalCodes": 1775,
	"./promotionalCodes.js": 1775,
	"./promotionalSportbookCampaings": 1776,
	"./promotionalSportbookCampaings.js": 1776,
	"./providers": 1777,
	"./providers.js": 1777,
	"./qualifying": 1778,
	"./qualifying.js": 1778,
	"./quotaRetraction": 1779,
	"./quotaRetraction.js": 1779,
	"./quotaRetractionReport": 1780,
	"./quotaRetractionReport.js": 1780,
	"./recargarCredito": 1781,
	"./recargarCredito.js": 1781,
	"./recargarCreditoAgente": 1782,
	"./recargarCreditoAgente.js": 1782,
	"./referralsAwardsReport": 1783,
	"./referralsAwardsReport.js": 1783,
	"./referralsReport": 1784,
	"./referralsReport.js": 1784,
	"./registerFast": 1785,
	"./registerFast.js": 1785,
	"./registeredDocument": 1786,
	"./registeredDocument.js": 1786,
	"./registeredDocuments": 1787,
	"./registeredDocuments.js": 1787,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 431,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 431,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 432,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 432,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 433,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 433,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 434,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 434,
	"./regulations/futureEvents/filterFutureEventsReports": 513,
	"./regulations/futureEvents/filterFutureEventsReports.js": 513,
	"./regulations/futureEvents/tableFutureEventsReports": 514,
	"./regulations/futureEvents/tableFutureEventsReports.js": 514,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 515,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 515,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 516,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 516,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 517,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 517,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 518,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 518,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 544,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 544,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 545,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 545,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 546,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 546,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 547,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 547,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 548,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 548,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 549,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 549,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 550,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 550,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 551,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 551,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 673,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 673,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 674,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 674,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 675,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 675,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 676,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 676,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 828,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 828,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 829,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 829,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 830,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 830,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 831,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 831,
	"./regulations/playerAccount/filterPlayerAccountReports": 832,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 832,
	"./regulations/playerAccount/tablePlayerAccountReports": 833,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 833,
	"./regulations/playerAccount2/filterPlayerAccountReports": 834,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 834,
	"./regulations/playerAccount2/tablePlayerAccountReports": 835,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 835,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 883,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 883,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 884,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 884,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 885,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 885,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 886,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 886,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 887,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 887,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 888,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 888,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 889,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 889,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 890,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 890,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 891,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 891,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 892,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 892,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 893,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 893,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 894,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 894,
	"./relationUserAggregator": 1788,
	"./relationUserAggregator.js": 1788,
	"./reportHash": 1789,
	"./reportHash.js": 1789,
	"./reportMarketing": 1790,
	"./reportMarketing.js": 1790,
	"./reports/affiliatesBetShop/filter": 207,
	"./reports/affiliatesBetShop/filter.js": 207,
	"./reports/affiliatesBetShop/table": 208,
	"./reports/affiliatesBetShop/table.js": 208,
	"./reports/assignmentQuota/filter": 292,
	"./reports/assignmentQuota/filter.js": 292,
	"./reports/assignmentQuota/table": 293,
	"./reports/assignmentQuota/table.js": 293,
	"./reports/assignmentQuotaMade/filter": 290,
	"./reports/assignmentQuotaMade/filter.js": 290,
	"./reports/assignmentQuotaMade/table": 291,
	"./reports/assignmentQuotaMade/table.js": 291,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 294,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 294,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 297,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 295,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 295,
	"./reports/balanceAdjustments/filter": 298,
	"./reports/balanceAdjustments/filter.js": 298,
	"./reports/balanceAdjustments/table": 299,
	"./reports/balanceAdjustments/table.js": 299,
	"./reports/balanceHistory/filter": 300,
	"./reports/balanceHistory/filter.js": 300,
	"./reports/balanceHistory/table": 301,
	"./reports/balanceHistory/table.js": 301,
	"./reports/balanceHistory2/filter": 1791,
	"./reports/balanceHistory2/filter.js": 1791,
	"./reports/balanceHistory2/filter2": 302,
	"./reports/balanceHistory2/filter2.js": 302,
	"./reports/balanceHistory2/table": 1792,
	"./reports/balanceHistory2/table.js": 1792,
	"./reports/balanceHistory2/table2": 303,
	"./reports/balanceHistory2/table2.js": 303,
	"./reports/balanceHistoryBetShop/filter": 306,
	"./reports/balanceHistoryBetShop/filter.js": 306,
	"./reports/balanceHistoryBetShop/table": 307,
	"./reports/balanceHistoryBetShop/table.js": 307,
	"./reports/balanceHistoryBetShop2/filter": 1793,
	"./reports/balanceHistoryBetShop2/filter.js": 1793,
	"./reports/balanceHistoryBetShop2/filter2": 308,
	"./reports/balanceHistoryBetShop2/filter2.js": 308,
	"./reports/balanceHistoryBetShop2/table": 1794,
	"./reports/balanceHistoryBetShop2/table.js": 1794,
	"./reports/balanceHistoryBetShop2/table2": 309,
	"./reports/balanceHistoryBetShop2/table2.js": 309,
	"./reports/balanceHistoryForAdminUser/filter": 304,
	"./reports/balanceHistoryForAdminUser/filter.js": 304,
	"./reports/balanceHistoryForAdminUser/table": 305,
	"./reports/balanceHistoryForAdminUser/table.js": 305,
	"./reports/balanceHistoryForAgent/filter": 310,
	"./reports/balanceHistoryForAgent/filter.js": 310,
	"./reports/balanceHistoryForAgent/table": 311,
	"./reports/balanceHistoryForAgent/table.js": 311,
	"./reports/balanceHistoryForBetShop/filter": 312,
	"./reports/balanceHistoryForBetShop/filter.js": 312,
	"./reports/balanceHistoryForBetShop/table": 313,
	"./reports/balanceHistoryForBetShop/table.js": 313,
	"./reports/balanceHistoryMachine/filter": 314,
	"./reports/balanceHistoryMachine/filter.js": 314,
	"./reports/balanceHistoryMachine/table": 315,
	"./reports/balanceHistoryMachine/table.js": 315,
	"./reports/balanceUsers/filter": 316,
	"./reports/balanceUsers/filter.js": 316,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 318,
	"./reports/balanceUsers/resume.js": 318,
	"./reports/balanceUsers/table": 317,
	"./reports/balanceUsers/table.js": 317,
	"./reports/betsReport/detailsReport": 1795,
	"./reports/betsReport/detailsReport.js": 1795,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1796,
	"./reports/betsReportBetShop/detailsReport.js": 1796,
	"./reports/betsReportBetShop/filterReport": 371,
	"./reports/betsReportBetShop/filterReport.js": 371,
	"./reports/betsReportBetShop/recordReport": 374,
	"./reports/betsReportBetShop/recordReport.js": 374,
	"./reports/betsReportBetShop/recordTableReport": 1797,
	"./reports/betsReportBetShop/recordTableReport.js": 1797,
	"./reports/betsReportBetShop/recordTableTransReport": 1798,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1798,
	"./reports/betsReportBetShop/recordTransReport": 373,
	"./reports/betsReportBetShop/recordTransReport.js": 373,
	"./reports/betsReportBetShop/tableReport": 372,
	"./reports/betsReportBetShop/tableReport.js": 372,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 379,
	"./reports/bonusReport/filterBonusReport.js": 379,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 380,
	"./reports/bonusReport/tableBonusReport.js": 380,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 381,
	"./reports/bonusReport2/filterBonusReport.js": 381,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1799,
	"./reports/bonusReport2/recordTableBonusReport.js": 1799,
	"./reports/bonusReport2/tableBonusReport": 382,
	"./reports/bonusReport2/tableBonusReport.js": 382,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 413,
	"./reports/casinoReport/filterCasinoReport.js": 413,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 414,
	"./reports/casinoReport/tableCasinoReport.js": 414,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1800,
	"./reports/casinoReport2/filterCasinoReport.js": 1800,
	"./reports/casinoReport2/filterCasinoReport2": 415,
	"./reports/casinoReport2/filterCasinoReport2.js": 415,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1801,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1801,
	"./reports/casinoReport2/tableCasinoReport": 1802,
	"./reports/casinoReport2/tableCasinoReport.js": 1802,
	"./reports/casinoReport2/tableCasinoReport2": 416,
	"./reports/casinoReport2/tableCasinoReport2.js": 416,
	"./reports/comissions_report/filter": 423,
	"./reports/comissions_report/filter.js": 423,
	"./reports/comissions_report/table": 424,
	"./reports/comissions_report/table.js": 424,
	"./reports/comissions_report2/filter": 425,
	"./reports/comissions_report2/filter.js": 425,
	"./reports/comissions_report2/table": 426,
	"./reports/comissions_report2/table.js": 426,
	"./reports/commisionsPay/filter": 427,
	"./reports/commisionsPay/filter.js": 427,
	"./reports/commisionsPay/table": 428,
	"./reports/commisionsPay/table.js": 428,
	"./reports/coupons_report/details": 1803,
	"./reports/coupons_report/details.js": 1803,
	"./reports/coupons_report/filter": 440,
	"./reports/coupons_report/filter.js": 440,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1804,
	"./reports/coupons_report/recordReports.js": 1804,
	"./reports/coupons_report/table": 441,
	"./reports/coupons_report/table.js": 441,
	"./reports/customReport/filter": 446,
	"./reports/customReport/filter.js": 446,
	"./reports/customReport/table": 447,
	"./reports/customReport/table.js": 447,
	"./reports/depositReport2/filter": 492,
	"./reports/depositReport2/filter.js": 492,
	"./reports/depositReport2/table": 493,
	"./reports/depositReport2/table.js": 493,
	"./reports/deposit_report/detailsDepositReports": 1017,
	"./reports/deposit_report/detailsDepositReports.js": 1017,
	"./reports/deposit_report/filterDepositReports": 490,
	"./reports/deposit_report/filterDepositReports.js": 490,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 491,
	"./reports/deposit_report/tableDepositReports.js": 491,
	"./reports/deposit_report_3/detailsDepositReports": 1018,
	"./reports/deposit_report_3/detailsDepositReports.js": 1018,
	"./reports/deposit_report_3/filterDepositReports": 494,
	"./reports/deposit_report_3/filterDepositReports.js": 494,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1805,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1805,
	"./reports/deposit_report_3/tableDepositReports": 495,
	"./reports/deposit_report_3/tableDepositReports.js": 495,
	"./reports/deposit_report_betshop/detailsDepositReports": 1019,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1019,
	"./reports/deposit_report_betshop/filterDepositReports": 496,
	"./reports/deposit_report_betshop/filterDepositReports.js": 496,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1806,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1806,
	"./reports/deposit_report_betshop/tableDepositReports": 497,
	"./reports/deposit_report_betshop/tableDepositReports.js": 497,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 505,
	"./reports/emailsReport/filterEmailsReport.js": 505,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1807,
	"./reports/emailsReport/recordTableEmailsReport.js": 1807,
	"./reports/emailsReport/tableEmailsReport": 506,
	"./reports/emailsReport/tableEmailsReport.js": 506,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 901,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 901,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 902,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 902,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 903,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 903,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 904,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 904,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 905,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 905,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1808,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1808,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 906,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 906,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 907,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 907,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1809,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1809,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1810,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1810,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 908,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 908,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 909,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 909,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 910,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 910,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 911,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 911,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1811,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1811,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 912,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 912,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 521,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 521,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 519,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 519,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 522,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 522,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 523,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 523,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 520,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 520,
	"./reports/historyMovement/filter": 524,
	"./reports/historyMovement/filter.js": 524,
	"./reports/historyMovement/table": 525,
	"./reports/historyMovement/table.js": 525,
	"./reports/historyMovementBetShop/filter": 526,
	"./reports/historyMovementBetShop/filter.js": 526,
	"./reports/historyMovementBetShop/table": 527,
	"./reports/historyMovementBetShop/table.js": 527,
	"./reports/historyPoints/filter": 528,
	"./reports/historyPoints/filter.js": 528,
	"./reports/historyPoints/table": 529,
	"./reports/historyPoints/table.js": 529,
	"./reports/informeCasino/detailsInformeCasino": 532,
	"./reports/informeCasino/detailsInformeCasino.js": 532,
	"./reports/informeCasino/filterInformeCasino": 530,
	"./reports/informeCasino/filterInformeCasino.js": 530,
	"./reports/informeCasino/recordInformeCasino": 533,
	"./reports/informeCasino/recordInformeCasino.js": 533,
	"./reports/informeCasino/recordTableInformeCasino": 1812,
	"./reports/informeCasino/recordTableInformeCasino.js": 1812,
	"./reports/informeCasino/tableInformeCasino": 531,
	"./reports/informeCasino/tableInformeCasino.js": 531,
	"./reports/informeGerencial/detailsInformeGerencial": 1813,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1813,
	"./reports/informeGerencial/filterInformeGerencial": 534,
	"./reports/informeGerencial/filterInformeGerencial.js": 534,
	"./reports/informeGerencial/recordInformeGerencial": 1814,
	"./reports/informeGerencial/recordInformeGerencial.js": 1814,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 535,
	"./reports/informeGerencial/tableInformeGerencial.js": 535,
	"./reports/informeGerencial2/detailsInformeGerencial": 1815,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1815,
	"./reports/informeGerencial2/filterInformeGerencial": 1816,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1816,
	"./reports/informeGerencial2/filterInformeGerencial2": 536,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 536,
	"./reports/informeGerencial2/recordInformeGerencial": 1817,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1817,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1818,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1818,
	"./reports/informeGerencial2/tableInformeGerencial": 1819,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1819,
	"./reports/informeGerencial2/tableInformeGerencial2": 537,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 537,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1820,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1820,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1821,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1821,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 538,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 538,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1822,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1822,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1823,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1823,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1824,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1824,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 539,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 539,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1825,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1825,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1826,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1826,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 540,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 540,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1827,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1827,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1828,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1828,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1829,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1829,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 541,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 541,
	"./reports/jackpotInternationalReport/filter": 542,
	"./reports/jackpotInternationalReport/filter.js": 542,
	"./reports/jackpotInternationalReport/table": 543,
	"./reports/jackpotInternationalReport/table.js": 543,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 552,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 552,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1830,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1830,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1831,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1831,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 553,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 553,
	"./reports/landingReport/detailsLandingReport": 556,
	"./reports/landingReport/detailsLandingReport.js": 556,
	"./reports/landingReport/filterLandingReport": 554,
	"./reports/landingReport/filterLandingReport.js": 554,
	"./reports/landingReport/recordLandingReport": 557,
	"./reports/landingReport/recordLandingReport.js": 557,
	"./reports/landingReport/recordTableLandingReport": 1832,
	"./reports/landingReport/recordTableLandingReport.js": 1832,
	"./reports/landingReport/tableLandingReport": 555,
	"./reports/landingReport/tableLandingReport.js": 555,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 558,
	"./reports/landingReport2/filterLandingReport.js": 558,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1833,
	"./reports/landingReport2/recordTableLandingReport.js": 1833,
	"./reports/landingReport2/tableLandingReport": 559,
	"./reports/landingReport2/tableLandingReport.js": 559,
	"./reports/limitationsReport/filterDepositReports": 576,
	"./reports/limitationsReport/filterDepositReports.js": 576,
	"./reports/limitationsReport/tableDepositReports": 577,
	"./reports/limitationsReport/tableDepositReports.js": 577,
	"./reports/logsUser/filter": 580,
	"./reports/logsUser/filter.js": 580,
	"./reports/logsUser/table": 581,
	"./reports/logsUser/table.js": 581,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 582,
	"./reports/loteryReport/filterLoteryReport.js": 582,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1834,
	"./reports/loteryReport/recordTableLoteryReport.js": 1834,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 583,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 583,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 584,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 584,
	"./reports/my_comissions_report/filter": 667,
	"./reports/my_comissions_report/filter.js": 667,
	"./reports/my_comissions_report/table": 668,
	"./reports/my_comissions_report/table.js": 668,
	"./reports/notesUser/filter": 669,
	"./reports/notesUser/filter.js": 669,
	"./reports/notesUser/table": 670,
	"./reports/notesUser/table.js": 670,
	"./reports/operatorResponsibility/filter": 671,
	"./reports/operatorResponsibility/filter.js": 671,
	"./reports/operatorResponsibility/table": 672,
	"./reports/operatorResponsibility/table.js": 672,
	"./reports/partners-categories/filter": 809,
	"./reports/partners-categories/filter.js": 809,
	"./reports/partners-categories/table": 810,
	"./reports/partners-categories/table.js": 810,
	"./reports/playersReport/detailsPlayersReport": 838,
	"./reports/playersReport/detailsPlayersReport.js": 838,
	"./reports/playersReport/filterPlayersReport": 836,
	"./reports/playersReport/filterPlayersReport.js": 836,
	"./reports/playersReport/recordPlayersReport": 839,
	"./reports/playersReport/recordPlayersReport.js": 839,
	"./reports/playersReport/recordTablePlayersReport": 840,
	"./reports/playersReport/recordTablePlayersReport.js": 840,
	"./reports/playersReport/tablePlayersReport": 837,
	"./reports/playersReport/tablePlayersReport.js": 837,
	"./reports/pointSettings/filter": 841,
	"./reports/pointSettings/filter.js": 841,
	"./reports/pointSettings/table": 842,
	"./reports/pointSettings/table.js": 842,
	"./reports/pointsUsers/filter": 843,
	"./reports/pointsUsers/filter.js": 843,
	"./reports/pointsUsers/table": 844,
	"./reports/pointsUsers/table.js": 844,
	"./reports/pokerReport/filterCasinoReport": 845,
	"./reports/pokerReport/filterCasinoReport.js": 845,
	"./reports/pokerReport/tableCasinoReport": 846,
	"./reports/pokerReport/tableCasinoReport.js": 846,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1835,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1835,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 677,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 677,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1836,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1836,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 913,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 913,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 678,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 678,
	"./reports/prizesLoyalty/filter": 847,
	"./reports/prizesLoyalty/filter.js": 847,
	"./reports/prizesLoyalty/table": 848,
	"./reports/prizesLoyalty/table.js": 848,
	"./reports/promotionalCasinoCampaings/filter": 864,
	"./reports/promotionalCasinoCampaings/filter.js": 864,
	"./reports/promotionalCasinoCampaings/table": 865,
	"./reports/promotionalCasinoCampaings/table.js": 865,
	"./reports/promotionalCodes/filter": 866,
	"./reports/promotionalCodes/filter.js": 866,
	"./reports/promotionalCodes/table": 867,
	"./reports/promotionalCodes/table.js": 867,
	"./reports/promotionalSpoortbookCampaings/filter": 868,
	"./reports/promotionalSpoortbookCampaings/filter.js": 868,
	"./reports/promotionalSpoortbookCampaings/table": 869,
	"./reports/promotionalSpoortbookCampaings/table.js": 869,
	"./reports/quotaRetraction/filter": 872,
	"./reports/quotaRetraction/filter.js": 872,
	"./reports/quotaRetraction/table": 873,
	"./reports/quotaRetraction/table.js": 873,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 874,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 874,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1837,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1837,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1838,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1838,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 875,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 875,
	"./reports/referralsReport/filterReferralsReports": 876,
	"./reports/referralsReport/filterReferralsReports.js": 876,
	"./reports/referralsReport/recordReferralsReports": 1839,
	"./reports/referralsReport/recordReferralsReports.js": 1839,
	"./reports/referralsReport/recordTableReferralsReports": 1840,
	"./reports/referralsReport/recordTableReferralsReports.js": 1840,
	"./reports/referralsReport/tableReferralsReports": 877,
	"./reports/referralsReport/tableReferralsReports.js": 877,
	"./reports/registeredDocuments/filter": 878,
	"./reports/registeredDocuments/filter.js": 878,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 880,
	"./reports/registeredDocuments/recordTable.js": 880,
	"./reports/registeredDocuments/table": 879,
	"./reports/registeredDocuments/table.js": 879,
	"./reports/relationUserAggregator/filter": 895,
	"./reports/relationUserAggregator/filter.js": 895,
	"./reports/relationUserAggregator/table": 896,
	"./reports/relationUserAggregator/table.js": 896,
	"./reports/reportHash/filter": 897,
	"./reports/reportHash/filter.js": 897,
	"./reports/reportHash/table": 898,
	"./reports/reportHash/table.js": 898,
	"./reports/reportMarketing/filter": 899,
	"./reports/reportMarketing/filter.js": 899,
	"./reports/reportMarketing/table": 900,
	"./reports/reportMarketing/table.js": 900,
	"./reports/rouletteReport/filter": 914,
	"./reports/rouletteReport/filter.js": 914,
	"./reports/rouletteReport/table": 915,
	"./reports/rouletteReport/table.js": 915,
	"./reports/sessionsReport/detailsSessionsReport": 916,
	"./reports/sessionsReport/detailsSessionsReport.js": 916,
	"./reports/sessionsReport/filterSessionsReport": 917,
	"./reports/sessionsReport/filterSessionsReport.js": 917,
	"./reports/sessionsReport/recordSessionsReport": 1033,
	"./reports/sessionsReport/recordSessionsReport.js": 1033,
	"./reports/sessionsReport/recordTableSessionsReport": 1034,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1034,
	"./reports/sessionsReport/tableSessionsReport": 918,
	"./reports/sessionsReport/tableSessionsReport.js": 918,
	"./reports/sessionsReport2/filter": 919,
	"./reports/sessionsReport2/filter.js": 919,
	"./reports/sessionsReport2/table": 920,
	"./reports/sessionsReport2/table.js": 920,
	"./reports/sportsPoolReport/filterReport": 921,
	"./reports/sportsPoolReport/filterReport.js": 921,
	"./reports/sportsPoolReport/tableReport": 922,
	"./reports/sportsPoolReport/tableReport.js": 922,
	"./reports/sportsTransactions/filter": 923,
	"./reports/sportsTransactions/filter.js": 923,
	"./reports/sportsTransactions/table": 924,
	"./reports/sportsTransactions/table.js": 924,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 925,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 925,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 926,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 926,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 927,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 927,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1841,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1841,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 928,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 928,
	"./reports/taxPaymentsReport/filter": 929,
	"./reports/taxPaymentsReport/filter.js": 929,
	"./reports/taxPaymentsReport/table": 930,
	"./reports/taxPaymentsReport/table.js": 930,
	"./reports/taxableEarnings/filter": 931,
	"./reports/taxableEarnings/filter.js": 931,
	"./reports/taxableEarnings/table": 932,
	"./reports/taxableEarnings/table.js": 932,
	"./reports/transactionReport/filter": 933,
	"./reports/transactionReport/filter.js": 933,
	"./reports/transactionReport/table": 934,
	"./reports/transactionReport/table.js": 934,
	"./reports/transfersReport/filter": 935,
	"./reports/transfersReport/filter.js": 935,
	"./reports/transfersReport/table": 936,
	"./reports/transfersReport/table.js": 936,
	"./reports/userAffiliatesAgent/filter": 937,
	"./reports/userAffiliatesAgent/filter.js": 937,
	"./reports/userAffiliatesAgent/table": 938,
	"./reports/userAffiliatesAgent/table.js": 938,
	"./reports/userAffiliatesBetShop/filter": 939,
	"./reports/userAffiliatesBetShop/filter.js": 939,
	"./reports/userAffiliatesBetShop/table": 940,
	"./reports/userAffiliatesBetShop/table.js": 940,
	"./reports/usuarioOnlineResumido/filter": 941,
	"./reports/usuarioOnlineResumido/filter.js": 941,
	"./reports/usuarioOnlineResumido/table": 942,
	"./reports/usuarioOnlineResumido/table.js": 942,
	"./reports/withdrawalReport2/filter": 943,
	"./reports/withdrawalReport2/filter.js": 943,
	"./reports/withdrawalReport2/table": 944,
	"./reports/withdrawalReport2/table.js": 944,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 945,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 945,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 946,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 946,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1842,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1842,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 947,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 947,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 948,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 948,
	"./reports/withdrawalRequestsComissions/filter": 949,
	"./reports/withdrawalRequestsComissions/filter.js": 949,
	"./reports/withdrawalRequestsComissions/table": 950,
	"./reports/withdrawalRequestsComissions/table.js": 950,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 951,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 951,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 952,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 952,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 953,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 953,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1843,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1843,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 954,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 954,
	"./reprintCheck": 1844,
	"./reprintCheck.js": 1844,
	"./requests/registration-requests/filter": 955,
	"./requests/registration-requests/filter.js": 955,
	"./requests/registration-requests/generateRequests": 956,
	"./requests/registration-requests/generateRequests.js": 956,
	"./requests/registration-requests/recordTableResponts": 957,
	"./requests/registration-requests/recordTableResponts.js": 957,
	"./requests/registration-requests/table": 959,
	"./requests/registration-requests/table.js": 959,
	"./requests/registration-requests/tableResponts": 958,
	"./requests/registration-requests/tableResponts.js": 958,
	"./requests/registrationRequests": 1845,
	"./requests/registrationRequests.js": 1845,
	"./resources-locale_es.json": 1947,
	"./restrictUser": 1846,
	"./restrictUser.js": 1846,
	"./reversionReload": 1847,
	"./reversionReload.js": 1847,
	"./rouletteReport": 1848,
	"./rouletteReport.js": 1848,
	"./security/adminuser/addAdminUser": 1849,
	"./security/adminuser/addAdminUser.js": 1849,
	"./security/adminuser/configuration/changePassword": 1850,
	"./security/adminuser/configuration/changePassword.js": 1850,
	"./security/adminuser/configuration/changePassword/changePasswordView": 960,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 960,
	"./security/adminuser/configuration/generateToken": 1851,
	"./security/adminuser/configuration/generateToken.js": 1851,
	"./security/adminuser/configuration/generateToken/filter": 961,
	"./security/adminuser/configuration/generateToken/filter.js": 961,
	"./security/adminuser/configuration/generateToken/table": 962,
	"./security/adminuser/configuration/generateToken/table.js": 962,
	"./security/adminuser/configuration/qrgoogle": 1852,
	"./security/adminuser/configuration/qrgoogle.js": 1852,
	"./security/adminuser/configuration/securityChanges": 1853,
	"./security/adminuser/configuration/securityChanges.js": 1853,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1854,
	"./security/adminuser/configurationAdminUser.js": 1854,
	"./security/adminuser/detailsAdminUser": 1855,
	"./security/adminuser/detailsAdminUser.js": 1855,
	"./security/adminuser/filterAdminUser": 205,
	"./security/adminuser/filterAdminUser.js": 205,
	"./security/adminuser/informationAdminUser": 1856,
	"./security/adminuser/informationAdminUser.js": 1856,
	"./security/adminuser/recordAdminUser": 1857,
	"./security/adminuser/recordAdminUser.js": 1857,
	"./security/adminuser/recordTableAdminUser": 963,
	"./security/adminuser/recordTableAdminUser.js": 963,
	"./security/adminuser/reports/logsUser": 1858,
	"./security/adminuser/reports/logsUser.js": 1858,
	"./security/adminuser/reports/logsUser/filter": 964,
	"./security/adminuser/reports/logsUser/filter.js": 964,
	"./security/adminuser/reports/logsUser/table": 965,
	"./security/adminuser/reports/logsUser/table.js": 965,
	"./security/adminuser/reportsAdminUser": 1859,
	"./security/adminuser/reportsAdminUser.js": 1859,
	"./security/adminuser/tableAdminUser": 206,
	"./security/adminuser/tableAdminUser.js": 206,
	"./security/approvalLogs/filter": 284,
	"./security/approvalLogs/filter.js": 284,
	"./security/approvalLogs/table": 285,
	"./security/approvalLogs/table.js": 285,
	"./security/approvalLogs2/filter": 286,
	"./security/approvalLogs2/filter.js": 286,
	"./security/approvalLogs2/table": 287,
	"./security/approvalLogs2/table.js": 287,
	"./security/approvalLogsBetShop/filter": 288,
	"./security/approvalLogsBetShop/filter.js": 288,
	"./security/approvalLogsBetShop/table": 289,
	"./security/approvalLogsBetShop/table.js": 289,
	"./security/contingencia/detailsContingencia": 1860,
	"./security/contingencia/detailsContingencia.js": 1860,
	"./security/contingencia/filterContingencia": 435,
	"./security/contingencia/filterContingencia.js": 435,
	"./security/contingencia/recordContingencia": 1861,
	"./security/contingencia/recordContingencia.js": 1861,
	"./security/contingencia/recordTableContingencia": 966,
	"./security/contingencia/recordTableContingencia.js": 966,
	"./security/contingencia/tableContingencia": 436,
	"./security/contingencia/tableContingencia.js": 436,
	"./security/menu/filter": 657,
	"./security/menu/filter.js": 657,
	"./security/menu/table": 658,
	"./security/menu/table.js": 658,
	"./security/perfil/detailsPerfil": 861,
	"./security/perfil/detailsPerfil.js": 861,
	"./security/perfil/filterPerfil": 859,
	"./security/perfil/filterPerfil.js": 859,
	"./security/perfil/recordPerfil": 862,
	"./security/perfil/recordPerfil.js": 862,
	"./security/perfil/recordTablePerfil": 863,
	"./security/perfil/recordTablePerfil.js": 863,
	"./security/perfil/tablePerfil": 860,
	"./security/perfil/tablePerfil.js": 860,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1862,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1862,
	"./security/perfilopciones2/filterPerfilOpciones": 1863,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1863,
	"./security/perfilopciones2/recordPerfilOpciones": 1864,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1864,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1865,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1865,
	"./security/perfilopciones2/tablePerfilOpciones": 1866,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1866,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1867,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1867,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1868,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1868,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1869,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1869,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1870,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1870,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1871,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1871,
	"./security/submenu/detailsSubMenu": 967,
	"./security/submenu/detailsSubMenu.js": 967,
	"./security/submenu/filterSubMenu": 968,
	"./security/submenu/filterSubMenu.js": 968,
	"./security/submenu/recordSubMenu": 969,
	"./security/submenu/recordSubMenu.js": 969,
	"./security/submenu/recordTableSubMenu": 970,
	"./security/submenu/recordTableSubMenu.js": 970,
	"./security/submenu/tableSubMenu": 971,
	"./security/submenu/tableSubMenu.js": 971,
	"./security/totalContingencies/table": 972,
	"./security/totalContingencies/table.js": 972,
	"./security/userSitebuilder/filter": 973,
	"./security/userSitebuilder/filter.js": 973,
	"./security/userSitebuilder/information": 1872,
	"./security/userSitebuilder/information.js": 1872,
	"./security/userSitebuilder/table": 974,
	"./security/userSitebuilder/table.js": 974,
	"./security/userVerification2/filter": 975,
	"./security/userVerification2/filter.js": 975,
	"./security/userVerification2/information": 1873,
	"./security/userVerification2/information.js": 1873,
	"./security/userVerification2/table": 976,
	"./security/userVerification2/table.js": 976,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1874,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1874,
	"./security/usuarioperfil/filterUsuarioPerfil": 977,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 977,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 978,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 978,
	"./security/usuarioperfil/recordUsuarioPerfil": 1875,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1875,
	"./security/usuarioperfil/tableUsuarioPerfil": 979,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 979,
	"./security/usuariosbloqueados/add": 1876,
	"./security/usuariosbloqueados/add.js": 1876,
	"./security/usuariosbloqueados/filter": 980,
	"./security/usuariosbloqueados/filter.js": 980,
	"./security/usuariosbloqueados/table": 981,
	"./security/usuariosbloqueados/table.js": 981,
	"./security/wallets/filter": 982,
	"./security/wallets/filter.js": 982,
	"./security/wallets/table": 983,
	"./security/wallets/table.js": 983,
	"./sessionsReport": 1877,
	"./sessionsReport.js": 1877,
	"./sessionsReport2": 1878,
	"./sessionsReport2.js": 1878,
	"./settings": 1879,
	"./settings.js": 1879,
	"./significantEventsAndAlterations": 1880,
	"./significantEventsAndAlterations.js": 1880,
	"./significantEventsAndAlterations2": 1881,
	"./significantEventsAndAlterations2.js": 1881,
	"./sportsPoolReport": 1882,
	"./sportsPoolReport.js": 1882,
	"./sportsTransactions": 1883,
	"./sportsTransactions.js": 1883,
	"./subMenu": 1884,
	"./subMenu.js": 1884,
	"./subProviders": 1885,
	"./subProviders.js": 1885,
	"./summaryBetsReport": 1886,
	"./summaryBetsReport.js": 1886,
	"./summaryCashFlow": 1887,
	"./summaryCashFlow.js": 1887,
	"./summaryCashFlow2": 1888,
	"./summaryCashFlow2.js": 1888,
	"./summaryCashFlowMachine": 1889,
	"./summaryCashFlowMachine.js": 1889,
	"./tags": 1890,
	"./tags.js": 1890,
	"./taxPaymentsReport": 1891,
	"./taxPaymentsReport.js": 1891,
	"./taxableEarnings": 1892,
	"./taxableEarnings.js": 1892,
	"./teacher/concessionaire/filterConcessionaire": 509,
	"./teacher/concessionaire/filterConcessionaire.js": 509,
	"./teacher/concessionaire/tableConcessionaire": 510,
	"./teacher/concessionaire/tableConcessionaire.js": 510,
	"./teacher/qualifying/filterQualifying": 870,
	"./teacher/qualifying/filterQualifying.js": 870,
	"./teacher/qualifying/tableQualifying": 871,
	"./teacher/qualifying/tableQualifying.js": 871,
	"./teacher/registered-documents/filterRegisteredDocuments": 881,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 881,
	"./teacher/registered-documents/tableRegisteredDocuments": 882,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 882,
	"./termsAndConditions": 1893,
	"./termsAndConditions.js": 1893,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 437,
	"./tools/countries/filter.js": 437,
	"./tools/countries/table": 438,
	"./tools/countries/table.js": 438,
	"./tools/translationManager": 1894,
	"./tools/translationManager.js": 1894,
	"./tools/translationManager/filter": 984,
	"./tools/translationManager/filter.js": 984,
	"./tools/translationManager/table": 985,
	"./tools/translationManager/table.js": 985,
	"./tools/uploadImage": 1895,
	"./tools/uploadImage.js": 1895,
	"./top": 1896,
	"./top.js": 1896,
	"./totalContingencies": 1897,
	"./totalContingencies.js": 1897,
	"./transactionReport": 1898,
	"./transactionReport.js": 1898,
	"./transactions": 1899,
	"./transactions.js": 1899,
	"./transactionsByPlayer": 1900,
	"./transactionsByPlayer.js": 1900,
	"./transactionsByPlayerDeposit": 1901,
	"./transactionsByPlayerDeposit.js": 1901,
	"./transactionsByPlayerFirstLevel": 1902,
	"./transactionsByPlayerFirstLevel.js": 1902,
	"./transactionsByPlayerSecondLevel": 1903,
	"./transactionsByPlayerSecondLevel.js": 1903,
	"./trasnfersReport": 1904,
	"./trasnfersReport.js": 1904,
	"./tutorials": 1905,
	"./tutorials.js": 1905,
	"./userAffiliatesAgent": 1906,
	"./userAffiliatesAgent.js": 1906,
	"./userAffiliatesBetShop": 1907,
	"./userAffiliatesBetShop.js": 1907,
	"./userManagement": 1908,
	"./userManagement.js": 1908,
	"./userManagement/userManagement/detailsUserManagement": 988,
	"./userManagement/userManagement/detailsUserManagement.js": 988,
	"./userManagement/userManagement/filterUserManagement": 986,
	"./userManagement/userManagement/filterUserManagement.js": 986,
	"./userManagement/userManagement/recordTableUserManagement": 990,
	"./userManagement/userManagement/recordTableUserManagement.js": 990,
	"./userManagement/userManagement/recordUserManagement": 989,
	"./userManagement/userManagement/recordUserManagement.js": 989,
	"./userManagement/userManagement/tableUserManagement": 987,
	"./userManagement/userManagement/tableUserManagement.js": 987,
	"./userProfile": 1909,
	"./userProfile.js": 1909,
	"./usersSitebuilder": 1910,
	"./usersSitebuilder.js": 1910,
	"./usersVerification": 1911,
	"./usersVerification.js": 1911,
	"./usersVerification/information": 991,
	"./usersVerification/information.js": 991,
	"./usersVerification2": 1912,
	"./usersVerification2.js": 1912,
	"./usersVerificationManagement": 1913,
	"./usersVerificationManagement.js": 1913,
	"./usuarioOnlineResumido": 1914,
	"./usuarioOnlineResumido.js": 1914,
	"./usuariosbloqueados": 1915,
	"./usuariosbloqueados.js": 1915,
	"./verifyAccount": 1916,
	"./verifyAccount.js": 1916,
	"./verifyAccountAgent": 1917,
	"./verifyAccountAgent.js": 1917,
	"./verifyAccountJumio": 1918,
	"./verifyAccountJumio.js": 1918,
	"./wallets": 1919,
	"./wallets.js": 1919,
	"./watchListReport": 1920,
	"./watchListReport.js": 1920,
	"./watchListReport/filterReport": 992,
	"./watchListReport/filterReport.js": 992,
	"./watchListReport/tableReport": 993,
	"./watchListReport/tableReport.js": 993,
	"./widgets": 1921,
	"./widgets.js": 1921,
	"./withdrawal": 1922,
	"./withdrawal.js": 1922,
	"./withdrawalReport2": 1923,
	"./withdrawalReport2.js": 1923,
	"./withdrawalRequests": 1924,
	"./withdrawalRequests.js": 1924,
	"./withdrawalRequestsBetShop": 1925,
	"./withdrawalRequestsBetShop.js": 1925,
	"./withdrawalRequestsComissions": 1926,
	"./withdrawalRequestsComissions.js": 1926,
	"./withdrawalRequestsForBetShop": 1927,
	"./withdrawalRequestsForBetShop.js": 1927,
	"./withdrawalRequestsForBetShop2": 1928,
	"./withdrawalRequestsForBetShop2.js": 1928,
	"./withdrawalRequestsRetail": 1929,
	"./withdrawalRequestsRetail.js": 1929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1939;